<template>
  <v-container>
    <v-row v-if="!getProductType">
      <v-container class="pa-30 ma-30">
        <Home />
      </v-container>
    </v-row>
    <div>
      <v-content class="hidden-sm-and-down" v-if="$route.path === '/' || currentApplicationName === 'fede' || currentApplicationName === 'home'">
        <v-app-bar style="height: 56px" app class="mx-auto overflow-hidden">
          <img src="@/assets/dco/Vector.png" class="logo-design" />
          <v-spacer />
          <div v-if="this.currentActionRoute === 'customerOnboarding'">
            <!-- Adding for locale selection -->
            <v-btn-toggle v-if="locales.length >= 2" v-model="localeToggle" active-class="toggle-active" borderless mandatory dense group
            @change="handleLocaleChanges">
              <v-btn
                v-for="(loc, index) in locales"
                :key="loc.code"
                plain
                class=""
                :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
              >{{loc.name}}
              <BaseIcon name="check" v-if="localeToggle === index"/>
                <v-divider
                  class="mx-2"
                  vertical
                  style="border-color: black;"
                  :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
                  v-if="index < locales.length - 1"
                ></v-divider>
              </v-btn>
              <!-- <v-btn>Lang 2
                <v-icon v-if="localeToggle === 1">mdi-check</v-icon>
              </v-btn> -->
            </v-btn-toggle>
            <!--  -->
            <v-btn
              rounded
              medium
              class="white--text text-none"
              :color="customCSS['landingPage-logIn-btnColor']"
              :style="{'font-family': customCSS['onboardingBtn-fontFamily']}"
              @click="logIn()"
              >{{ $t('dcoResources.logIn') }}</v-btn
            >
          </div>
        </v-app-bar>
      </v-content>
    </div>
    <v-row
      v-if="dataObj && dataObj.data && !dataObj.data.wizardSteps.length"
      class="news-content mobile-spacing"
    >
      <v-spacer></v-spacer>
      <v-btn
        v-if="currentActionRouteSearch && navigationMapping[currentRoute][currentSubRoute].create"
        @click="createNewForm()"
        fab
        small
        :class="`${customCSS['primary']} mr-3 mt-9 mb-2`"
      >
        <BaseIcon name="add" color="white" iconClass="pr-2"/>
      </v-btn>
    </v-row>
    <v-card
      flat
      v-if="
        currentActionRoute !== 'customerOnboarding' &&
        currentActionRoute !== 'resume' &&
        currentActionRoute !== 'otpVerification'
      "
      :class="
        dataObj && dataObj.data && dataObj.data.wizardSteps.length
          ? 'mt-5'
          : 'v-card--material form-container'
      "
      class="landing-card news-content"
    >
      <toast
        :config="alertMessage"
        v-if="alertMessage && alertMessage.component === 'alert' && isAlertVisibile"
      />
      <div v-if="currentActionRoute === 'productOnboard' || currentActionRoute === 'secondaryApplicantOnboard'">
        <h4
        class="landingPage-productData text-center text-none"
        :style="{
          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          color: customCSS && customCSS['onboarding-sectionSubTitleColor']
        }"
        >
          <br />
          Onboard for {{ this.productData.data.productDescription }}<br />
        </h4>
      </div>
      <v-container fluid class="pa-0 ma-0" v-if="currentActionRoute === 'otpVerificationProduct'">
        <div class="hidden-md-and-up d-flex align-center justify-center">
          <img src="@/assets/dco/Vector.png" class="hidden-md-and-up mobile-placement tab-logo" />
        </div>
      </v-container>
      <v-form
        ref="renderForm"
        v-if="formCode && dataObj"
        :style="{
          'background-color': customCSS && customCSS['formContent-backgroundColor'],
        }"
        :class="
          currentActionRoute === 'eligibilityCheck' || currentActionRoute === 'productOnboard' || currentActionRoute === 'secondaryApplicantOnboard'
            ? 'desktop-spacing'
            : ''
        "
      >
        <FEUIRender
          :key="componentKey"
          :path="formCode"
          :JSONSchema="dataObj"
          :formInput="formInput"
          :customCSS="customCSS"
          @update="handleFormUpdate"
          @submit="onSubmit"
          @action="onAction"
          @toggle="onToggle"
          @updateFormInfo="onUpdateFormInfo"
          @reset="onReset"
          @panelErrorMessage="panelErrorMessage"
          @panelApiCallMessage="panelApiCallMessage"
        />
      </v-form>
      <v-form v-if="modalConfig.enabled">
        <v-flex xs2 sm2 md2 lg2 xl2>
          <Modal :config="modalConfig">
            <FEUIRender
              v-if="rendererModal"
              slot="modalContent"
              :key="modalComponentKey"
              :path="modalFormCode"
              :JSONSchema="modelDataObj"
              :formInput="modalFormInput"
              :customCSS="customCSS"
              :parentValue="parentValue"
              @update="handleFormUpdate"
              @submit="onSubmit"
              @action="onAction"
              @toggle="onToggle"
              @updateFormInfo="onUpdateFormInfo"
              @reset="onReset"
              @panelErrorMessage="panelErrorMessage"
              @panelApiCallMessage="panelApiCallMessage"
            />
          </Modal>
        </v-flex>
      </v-form>
      <Modal v-if="!rendererModal" :config="modalConfig" @cancel="onCancel" />
    </v-card>
    <v-row
      v-if="currentActionRoute === 'customerOnboarding'"
      class="justify-center hidden-sm-and-down pt-16"
    >
      <v-col cols="2">
        <v-card flat class="d-xl-none">
          <img :src="landingPainter" :class="landingPainter !== '' && landingPainter !== null ? $vuetify.rtl ? 'landing-painter-rtl':'landing-painter' : ''" alt="" />
          <img :src="purpleImage" :class="purpleImage !== '' && purpleImage !== null ? $vuetify.rtl ? 'flower-purple-rtl': 'flower-purple' : ''" alt="" />
          <img :src="pinkImage" :class="pinkImage !== '' && pinkImage !== null ? $vuetify.rtl ? 'flower-pink-rtl': 'flower-pink' : ''" alt="" />
        </v-card>
        <v-card flat class="hidden-lg-and-down">
          <img :src="landingPainter" :class="landingPainter !== '' && landingPainter !== null ? 'landing-painter-xl' : ''" alt="" />
          <img :src="purpleImage" :class="purpleImage !== '' && purpleImage !== null ? 'flower-purple-xl' : ''" alt="" />
          <img :src="pinkImage" :class="pinkImage !== '' && pinkImage !== null ? 'flower-pink-xl' : ''" alt="" />
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card
          width="100vh"
          flat
          class="justify-center align-center content-center d-flex flex-column flex-wrap mt-5"
          color="transparent"
        >
          <h4 class="text-center" :style="{
            color: customCSS && customCSS['landingPage-titleColor'],
            'font-family': customCSS && customCSS['formTitle-fontFamily']
          }">
            <span v-if="getProductType === 'currentAccount'">{{ $t('landingScreen.financeCurrentAccount') }}</span>
                  <span v-if="getProductType === 'savings'">{{ $t('landingScreen.financeSavings') }}</span>
                  <span v-if="getProductType === 'termDeposit'">{{ $t('landingScreen.financeTd') }}</span>
                  <span v-if="getProductType === 'cashISA'">{{ $t('landingScreen.financeCashIsa') }}</span>
                  <span v-if="getProductType === 'noticeDeposit'">{{ $t('landingScreen.financeNotice') }}</span>
                  <span v-if="getProductType === 'lifetimeISA'">{{ $t('landingScreen.financeLifetimeIsa') }}</span></h4>
          <h1
          class="landingPage-Title"
          :style="{
            'font-family': customCSS && customCSS['formTitle-fontFamily'],
            color: customCSS && customCSS['landingPage-subTitleColor']
          }"
          >
            {{ $t('landingScreen.welcome') }}
          </h1>
          <p
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          }"
          >{{ productData.data.productDescription }}</p>
          <img :src="dcoLandingLine" :class="dcoLandingLine !== '' && dcoLandingLine !== null ? 'landing-image' : ''" alt=""/>
          <v-btn
            large
            @click="productIntro()"
            rounded
            :color="customCSS['primary']"
            class="landingPage-btn white--text text-none"
            :style="{
              'font-family': customCSS['onboardingBtn-fontFamily'],
              bottom: '-41px'
            }"
            >{{ $t('dcoResources.newcustomer') }}</v-btn
          >
          <v-btn
            large
            rounded
            outlined
            :color="customCSS['primary']"
            class="landingPage-btn d-flex text-none"
            :style="{
              'font-family': customCSS['onboardingBtn-fontFamily'],
              bottom: '-62px'
            }"
            @click="productCompare()"
            >{{ $t('dcoResources.resumeOnboarding') }}</v-btn
          >
          <v-row class="justify-center">
            <v-col cols="11">
          <div style="position: relative; bottom: -67px; font-size: 12px color: black;">
            <p class="small-text text-center">
              {{ $t('dcoResources.continueApplication') }}
            </p>
          </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <!-- Mobile phone view -->
    <v-row
      v-if="currentActionRoute === 'customerOnboarding'"
      class="hidden-md-and-up"
      style="margin-top: -12px !important"
      :offset-lg="$vuetify.rtl ? 2 : 0"
    >
      <v-card
        flat
        width="100vw"
        class="hidden-sm-and-up d-flex grow flex-wrap align-center"
        style="justify-content: center"
        color="transparent"
      >
        <v-card
          flat
          class="justify-center align-center"
          color="transparent"
          style="display: flex; flex-direction: column"
        >
          <img src="@/assets/dco/mobile_logo.png" class="mobile-placement" alt="" />
          <v-img
          v-if="planetImage"
           :src="planetImage" class="planet-placement" max-width="227px" alt="">
            <v-overlay absolute :color="customCSS['transparent']">
              <v-card flat :color="customCSS['transparent']">
                <p
                class="landingPage-subTitle pt-12 mt-1"
                :style="{
                  'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  color : customCSS['landingPage-mobile-titleColor'],
                  position: 'relative',
                  top: '20px'
                  }"
                >
                <span v-if="getProductType === 'currentAccount'">{{ $t('landingScreen.financeCurrentAccount') }}</span>
                  <span v-if="getProductType === 'savings'">{{ $t('landingScreen.financeSavings') }}</span>
                  <span v-if="getProductType === 'termDeposit'">{{ $t('landingScreen.financeTd') }}</span>
                  <span v-if="getProductType === 'cashISA'">{{ $t('landingScreen.financeCashIsa') }}</span>
                  <span v-if="getProductType === 'noticeDeposit'">{{ $t('landingScreen.financeNotice') }}</span>
                  <span v-if="getProductType === 'lifetimeISA'">{{ $t('landingScreen.financeLifetimeIsa') }}</span>
                </p>
                <p
                class="landingPage-subTitle1"
                :style="{
                  'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  'color' : customCSS['landingPage-mobile-subTitleColor'],
                  position: 'relative',
                  }"
                >
                  <br />{{ $t('landingScreen.welcome') }}
                </p>
              </v-card>
            </v-overlay>
          </v-img>
          <v-card
            v-else
            flat
            :color="customCSS['transparent']"
            class="planet-placement mx-auto"
          >
            <p
            class="landingPage-subTitle pt-12 mt-1"
            :style="{
              'font-family': customCSS && customCSS['formTitle-fontFamily'],
              color : customCSS['landingPage-mobile-titleColor'],
              position: 'relative',
              top: '20px'
              }"
            >
            <span v-if="getProductType === 'currentAccount'">{{ $t('landingScreen.financeCurrentAccount') }}</span>
              <span v-if="getProductType === 'savings'">{{ $t('landingScreen.financeSavings') }}</span>
              <span v-if="getProductType === 'termDeposit'">{{ $t('landingScreen.financeTd') }}</span>
              <span v-if="getProductType === 'cashISA'">{{ $t('landingScreen.financeCashIsa') }}</span>
              <span v-if="getProductType === 'noticeDeposit'">{{ $t('landingScreen.financeNotice') }}</span>
              <span v-if="getProductType === 'lifetimeISA'">{{ $t('landingScreen.financeLifetimeIsa') }}</span>
            </p>
            <p
            class="landingPage-subTitle1"
            :style="{
              'font-family': customCSS && customCSS['formTitle-fontFamily'],
              'color' : customCSS['landingPage-mobile-subTitleColor'],
              position: 'relative',
              }"
            >
              <br />{{ $t('landingScreen.welcome') }}
            </p>
          </v-card>
          <img :src="rocketImage" :class="rocketImage !== '' && rocketImage !== null ? 'rocket-placement' : ''" alt="" />
          <v-btn
            large
            @click="$router.push({ params: { action: 'productInfo' } })"
            rounded
            :color="customCSS['onboardingHelper-btnColor']"
            class="landingPage-btn black--text text-none"
            :style="{
              'font-family': customCSS['onboardingBtn-fontFamily'],
            }"
            ><span :style="{ 'color' : customCSS['onboardingHelper-btnTextcolor']}">{{ $t('productIntroduction.newcustomer') }}</span></v-btn
          >
          <v-btn
            large
            rounded
            outlined
            class="text-none"
            :color="customCSS['onboardingHelper-btnColor']"
            :style="{
              'font-family': customCSS['onboardingBtn-fontFamily'],
              top: '15px'
            }"
            @click="productCompare()"
            >{{ $t('productIntroduction.resumeonboardingbtn') }}</v-btn
          >
          <p class="small-text-mobile mt-7" :style="{ 'color' : customCSS['onboardingHelper-color']}">{{ $t('productIntroduction.resumeinfo') }}</p>
          <v-img src="@/assets/dco/mobile-line.png" width="356px" height="34px" alt=""></v-img>
          <p class="log-text" :style="{ 'color' : customCSS['onboardingHelper-color']}">{{ $t('productIntroduction.alreadyaclient') }}</p>
          <v-btn
            large
            rounded
            text
            @click="logIn()"
            :color="customCSS['onboardingHelper-btnColor']"
            class="landingPage-btn text-none"
            :style="{
              'font-family': customCSS['onboardingBtn-fontFamily'],
              position: 'relative',
              top: '-21px'
            }"
            >{{ $t('productIntroduction.loginbtn') }}</v-btn
          >
        </v-card>
      </v-card>
      <v-btn v-if="locales.length >= 2" class="feedback-btn" @click="localeDialog = true">
        <img src="@/assets/dco/ar.png" class="feedback-txt" v-if="$vuetify.rtl" />
        <img src="@/assets/dco/uk.png" class="feedback-txt" v-else />
      </v-btn>
      <v-dialog
      v-model="localeDialog"
      max-width="350"
    >
      <v-card class="rounded-lg">
        <p class="text-h5 text-center pt-5">
          Choose your language<br/>
          اختر لغتك
        </p>

        <v-card-text class="text-center">
          <!-- Adding for locale selection -->
            <v-btn-toggle v-model="localeToggle" active-class="toggle-active" borderless mandatory dense group
            @change="handleLocaleChanges">
              <p>
                <v-btn
                v-for="(loc, index) in locales"
                :key="loc.code"
                outlined
                class="locale-buttons ma-2"
                style="width: 40vw;"
                :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
              >{{loc.name}}
              <BaseIcon name="check" v-if="localeToggle === index"/>
              </v-btn></p>
            </v-btn-toggle>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </v-row>
    <!-- product Introduction Start-->
    <v-row v-if="currentActionRoute === 'productInfo'">
      <v-container class="pt-14">
        <v-row style="pt-14">
          <v-card flat class="d-flex grow flex-wrap align-center mobile-alignment">
            <img
              src="@/assets/dco/mobile-product.png"
              class="hidden-md-and-up mobile-placement"
              style="justify-self: center"
              alt=""
            />
            <div style="padding-left: 0px">
              <h4 class="fin-color align-center mobile-alignment pt-4"
              :style="{
                color: customCSS && customCSS['productIntroduction-titleColor']
              }"
              >
                {{ $t('productIntroduction.finance') }}<br /><br />
              </h4>
              <p
                class="landingPage-productData mobile-alignment"
                :style="{
                  'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  'letter-spacing': '0.15px'
                }"
              >
                {{ $t('productIntroduction.onboardMessage') }}
              </p>
              <div v-if="this.currentActionRoute === 'productInfo'"></div>
              <div>
                <h3
                class="landingPage-subTitle1 mobile-alignment"
                :style="{
                  'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  }"
                >
                  {{ this.productData.data.productDescription }}
                </h3>
              </div>
            </div>
          </v-card>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-card flat class="d-flex grow flex-wrap align-center">
              <div style="padding-left: 0px">
                <div class="justify-center">
                  <img src="@/assets/dco/product_info_painter.png" class="product-painter" alt="" />
                  <p class="align-self-end justify-center landingPage-productData"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    color: customCSS && customCSS['onboarding-sectionContentColor'],
                    'letter-spacing': '0.15px'
                  }"
                  style="display: flex">
                    <strong> {{ $t('productIntroduction.exploremoreproducts') }} </strong>
                    <v-btn
                      large
                      rounded
                      class="text-none"
                      text
                      :color="customCSS['primary']"
                      style="bottom: 9px"
                      :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
                      @click="bankProduct()"
                      >{{ $t('dcoResources.here') }}</v-btn
                    >
                  </p>
                </div>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6">
            <v-card flat class="d-flex grow flex-wrap justify-center align-center mobile-test">
              <div>
                <p
                  class="resume-helper"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  }"
                >
                  {{ $t('productIntroduction.productIntro') }}
                </p>
                <p
                  class="resume-text"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    color: customCSS && customCSS['onboarding-sectionContentColor']
                  }"
                  v-if="$te('productIntroduction.validId')"
                >
                <BaseIcon :name="$appSettings.dco.productIntroductionScreen.icons.account" :color="customCSS['grey']" iconClass="vertical-alignment"/>
                <strong>&nbsp;&nbsp;{{ $t('productIntroduction.validId') }}</strong>
                </p>
                <p
                  class="resume-text"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    color: customCSS && customCSS['onboarding-sectionContentColor']
                  }"
                  v-if="$te('productIntroduction.selfie')"
                >
                <BaseIcon :name="$appSettings.dco.productIntroductionScreen.icons.camera" :color="customCSS['grey']" iconClass="vertical-alignment"/>
                <strong>&nbsp;&nbsp;{{ $t('productIntroduction.selfie') }}</strong>
                </p>
                <p
                  class="resume-text"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    color: customCSS && customCSS['onboarding-sectionContentColor']
                  }"
                  v-if="$te('productIntroduction.postalCode')"
                >
                <BaseIcon :name="$appSettings.dco.productIntroductionScreen.icons.location" :color="customCSS['grey']" iconClass="vertical-alignment"/>
                <strong>&nbsp;&nbsp;{{ $t('productIntroduction.postalCode') }}</strong>
                </p>
                <p
                class="resume-helper"
                :style="{
                  'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                }"
                >
                  {{ $t('productIntroduction.acknowledge') }}<br />
                </p>
                <p
                  class="resume-text"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    color: customCSS && customCSS['onboarding-sectionContentColor']
                  }"
                  v-if="$te('productIntroduction.ukResidentCa') || $te('productIntroduction.ukResidentSa') || $te('productIntroduction.ukResidentTd') ||
                  $te('productIntroduction.ukResidentIsa') || $te('productIntroduction.ukResidentNotice') || $te('productIntroduction.ukResidentLifetimeIsa')"
                >
                <BaseIcon :name="$appSettings.dco.productIntroductionScreen.icons.check" :color="customCSS['grey']" iconClass="vertical-alignment"/>
                  <span v-if="getProductType === 'currentAccount'"><strong>&nbsp;&nbsp;{{ $t('productIntroduction.ukResidentCa') }}</strong></span>
                  <span v-if="getProductType === 'savings'"><strong>&nbsp;&nbsp;{{ $t('productIntroduction.ukResidentSa') }}</strong></span>
                  <span v-if="getProductType === 'termDeposit'"><strong>&nbsp;&nbsp;{{ $t('productIntroduction.ukResidentTd') }}</strong></span>
                  <span v-if="getProductType === 'cashISA'"><strong>&nbsp;&nbsp;{{ $t('productIntroduction.ukResidentCashIsa') }}</strong></span>
                  <span v-if="getProductType === 'noticeDeposit'"><strong>&nbsp;&nbsp;{{ $t('productIntroduction.ukResidentNotice') }}</strong></span>
                  <span v-if="getProductType === 'lifetimeISA'"><strong>&nbsp;&nbsp;{{ $t('productIntroduction.ukResidentLifetimeIsa') }}</strong></span>
                </p>
                <p
                  class="resume-text"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    color: customCSS && customCSS['onboarding-sectionContentColor']
                  }"
                  v-if="$te('productIntroduction.ukPhoneNumber')"
                >
                <BaseIcon :name="$appSettings.dco.productIntroductionScreen.icons.check" :color="customCSS['grey']" iconClass="vertical-alignment"/>
                  <strong>&nbsp;&nbsp;{{ $t('productIntroduction.ukPhoneNumber') }}</strong>
                </p>
                <br />
                <div class="mobile-alignment">
                  <v-btn
                    large
                    rounded
                    :color="customCSS['primary']"
                    class="white--text text-none mobile-alignment"
                    :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
                    @click="productInfoo()"
                    >{{ $t('dcoResources.continueBtn') }}</v-btn
                  >
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <!-- <Product /> -->
    </v-row>
    <v-row
      v-if="
        (currentActionRoute === 'resume' && this.dataNotFound === false && invalidProductCode === false) ||
        (currentActionRoute === 'otpVerification' && dataNotFound === false)
      "
      class="ma-0"
    >
      <v-container fluid class="pa-0 ma-0">
        <div class="hidden-md-and-up d-flex align-center desktop-alignment">
          <img src="@/assets/dco/Vector.png" class="hidden-md-and-up mobile-placement tab-logo" />
        </div>
      </v-container>
      <div
        v-if="productSame === false && previousExpired === false"
        style="position: relative; top: 70px"
        class="resume-laptop"
      >
        <h4 class="fin-color mobile-resume">{{ $t('productIntroduction.finance') }}</h4>
        <h3
          class="landingPage-subTitle1 pt-6"
          :style="{
            'font-family': customCSS && customCSS['formTitle-fontFamily'],
            color: customCSS && customCSS['onboarding-sectionSubTitleColor']
          }"
        >
        {{ $t('dcoResources.welcomeBack') }}<br/> {{ $t('dcoResources.applicationPending')}}
        </h3>
        <p
          class="resume-text"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
            'letter-spacing': '0.5px',
            color: customCSS && customCSS['onboarding-sectionContentColor']
          }"
        >
        {{ $t('dcoResources.twoDifferentProducts') }}
        </p>
      </div>
      <div
        v-else-if="productSame === false && previousExpired === true"
        style="position: relative; top: 70px"
        class="resume-laptop"
      >
        <h4 class="fin-color mobile-resume">{{ $t('productIntroduction.finance') }}</h4>
        <h3
          class="landingPage-subTitle1 pt-6"
          :style="{
            'font-family': customCSS && customCSS['formTitle-fontFamily'],
            color: customCSS && customCSS['onboarding-sectionSubTitleColor']
          }"
        >
        {{ $t('dcoResources.welcomeBack') }}<br/>{{ $t('dcoResources.productNotActive') }}
        </h3>
        <p
          class="resume-text"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
            'letter-spacing': '0.5px',
            color: customCSS && customCSS['onboarding-sectionContentColor']
          }"
        >
        {{ $t('dcoResources.previousProductNotActive') }}
        </p>
      </div>
      <v-col cols="12" sm="6" class="resume-twoProducts">
        <v-row
          class="justify-center"
          v-if="currentActionRoute === 'resume' || currentActionRoute === 'otpVerification'"
        >
          <v-container fluid class="pa-0 ma-0">
            <v-flex class="mt-16">
              <v-card flat col="6" v-if="this.productSame === true">
                <v-form
                  ref="renderForm"
                  v-if="formCode && dataObj"
                  :style="{
                    'background-color': customCSS && customCSS['formContent-backgroundColor'],
                  }"
                >
                  <FEUIRender
                    :key="componentKey"
                    :path="formCode"
                    :JSONSchema="dataObj"
                    :formInput="formInput"
                    :customCSS="customCSS"
                    @update="handleFormUpdate"
                    @submit="onSubmit"
                    @action="onAction"
                    @toggle="onToggle"
                    @reset="onReset"
                    @panelErrorMessage="panelErrorMessage"
                    @panelApiCallMessage="panelApiCallMessage"
                  />
                </v-form>
                <v-form v-if="modalConfig.enabled">
                  <v-flex xs2 sm2 md2 lg2 xl2>
                    <Modal :config="modalConfig">
                      <FEUIRender
                        v-if="rendererModal"
                        slot="modalContent"
                        :key="modalComponentKey"
                        :path="modalFormCode"
                        :JSONSchema="modelDataObj"
                        :formInput="modalFormInput"
                        :customCSS="customCSS"
                        :parentValue="parentValue"
                        @update="handleFormUpdate"
                        @submit="onSubmit"
                        @action="onAction"
                        @toggle="onToggle"
                        @reset="onReset"
                        @panelErrorMessage="panelErrorMessage"
                        @panelApiCallMessage="panelApiCallMessage"
                      />
                    </Modal>
                  </v-flex>
                </v-form>
                <Modal v-if="!rendererModal" :config="modalConfig" @cancel="onCancel" />
              </v-card>
              <v-card flat col="12" v-if="this.productSame === false">
                <v-form
                  ref="renderForm"
                  v-if="formCode && dataObj"
                  :style="{
                    'background-color': customCSS && customCSS['formContent-backgroundColor'],
                  }"
                >
                  <FEUIRender
                    :key="componentKey"
                    :path="formCode"
                    :JSONSchema="dataObj"
                    :formInput="formInput"
                    :customCSS="customCSS"
                    @update="handleFormUpdate"
                    @submit="onSubmit"
                    @action="onAction"
                    @toggle="onToggle"
                    @reset="onReset"
                    @panelErrorMessage="panelErrorMessage"
                    @panelApiCallMessage="panelApiCallMessage"
                  />
                </v-form>
                <v-form v-if="modalConfig.enabled">
                  <v-flex xs2 sm2 md2 lg2 xl2>
                    <Modal :config="modalConfig">
                      <FEUIRender
                        v-if="rendererModal"
                        slot="modalContent"
                        :key="modalComponentKey"
                        :path="modalFormCode"
                        :JSONSchema="modelDataObj"
                        :formInput="modalFormInput"
                        :customCSS="customCSS"
                        :parentValue="parentValue"
                        @update="handleFormUpdate"
                        @submit="onSubmit"
                        @action="onAction"
                        @toggle="onToggle"
                        @reset="onReset"
                        @panelErrorMessage="panelErrorMessage"
                        @panelApiCallMessage="panelApiCallMessage"
                      />
                    </Modal>
                  </v-flex>
                </v-form>
                <Modal v-if="!rendererModal" :config="modalConfig" @cancel="onCancel" />
              </v-card>
            </v-flex>
          </v-container>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" class=".d-none px-0 pt-16" v-if="this.productSame === true">
        <v-img src="@/assets/dco/resumeOnboarding.png" class="d-none d-sm-block resume-onboarding" alt=""/>
      </v-col>
    </v-row>
    <!-- Resume process with no pending application found. -->
    <v-row v-if="this.dataNotFound === true">
      <v-container fluid class="pa-0 ma-0">
        <div class="hidden-md-and-up d-flex align-center justify-center">
          <img src="@/assets/dco/Vector.png" class="hidden-md-and-up mobile-placement tab-logo" alt="" />
        </div>
      </v-container>
      <v-container class="pt-14">
        <v-row style="padding: 14px">
          <v-col cols="12" sm="6">
            <v-card flat class="d-flex grow flex-wrap flex-column">
              <h4 class="fin-color align-center mobile-alignment pt-4"
              :style="{
            color: customCSS && customCSS['landingPage-titleColor']
          }"
              >
                {{ $t('dcoResources.finance') }}<br /><br />
              </h4>
              <h2
                class="noData-title"
                :style="{
                  'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  color: customCSS && customCSS['onboarding-sectionSubTitleColor']
                }"
              >
                {{ $t('dcoResources.welcome') }}
              </h2>
              <p
                class="resume-helper"
                :style="{
                  'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  'letter-spacing': '0.5px',
                  color: customCSS && customCSS['onboarding-sectionContentColor']
                }"
              >
              {{ $t('dcoResources.noDataFound') }}
              </p>
              <p
                class="chosen-product"
                :style="{
                  'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  color: customCSS && customCSS['onboarding-sectionHelperTextColor']
                }"
              >
              {{ $t('dcoResources.mobileNumberProvided') }}
              </p>
              <h5
                class="noData-content"
                :style="{
                  'font-family': customCSS && customCSS['formTitle-fontFamily'],
                  color: customCSS && customCSS['onboarding-sectionSubTitleColor']
                }"
              >
                {{ mobileNumber }}
              </h5>
              <v-card outlined flat shaped>
                <v-card outlined flat shaped class="justify-center dataNotFound-card">
                  <v-row class="ma-3">
                    <v-col
                      cols="2"
                      class="d-flex align-center justify-center"
                      style="padding-right: 0px;"
                    >
                      <BaseIcon :color="customCSS['primary']" iconClass="justify-center" name="shield_alert"/>
                    </v-col>
                    <v-col
                      style="padding-left: 0px; padding-bottom: 0px;"
                      class="justify-center"
                    >
                      <p
                        class="noData-helper"
                        :style="{
                          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                        }"
                      >
                      {{ $t('dcoResources.noDataFoundForNumber') }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row class="ma-3">
                    <v-col cols="2"> </v-col>
                    <v-col
                      :class="$vuetify.rtl ? 'd-flex align-center justify-center pr-0 pl-2' : 'd-flex align-center justify-center px-0'"
                      style="padding-top: 0px"
                    >
                      <p
                        class="contact-helper text-start"
                        :style="{
                          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                        }"
                      >
                      {{ $t('dcoResources.noDataHelperText') }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row class="ma-3">
                    <v-col class="text-right">
                      <v-btn
                        medium
                        rounded
                        outlined
                        :color="customCSS['primary']"
                        class="landingPage-btn text-none mb-3"
                        :style="{
                          'font-family': customCSS && customCSS['onboardingBtn-fontFamily'],
                        }"
                        @click="dataFunction()"
                        >{{ $t('dcoResources.tryAgain') }}</v-btn
                      >
                      <v-btn
                        medium
                        @click="dataNotFound=false,$router.push({ params: { action: 'productInfo' } })"
                        rounded
                        :color="customCSS['primary']"
                        class="landingPage-btn white--text text-none mb-3"
                        :style="{
                          'font-family': customCSS && customCSS['onboardingBtn-fontFamily'],
                        }"
                        style="left: 4px;right: 4px;"
                        >{{ $t('dcoResources.startOnboarding') }}</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-card>
              </v-card>
            </v-card>
          </v-col>
          <v-col cols="12" sm="6" class=".d-none .d-sm-flex">
            <img
              src="@/assets/dco/resumeOnboarding.png"
              class="d-none d-sm-block resumeOnboarding-dataNotFound"
              alt=""
            />
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <!-- Resume process with product invalid/Expired. -->
    <v-row v-if="this.invalidProductCode === true">
      <v-container>
        <h4 class="fin-color"
        :style="{
            color: customCSS && customCSS['landingPage-titleColor']
          }"
        >{{ $t('productIntroduction.finance') }}<br /></h4>
        <br />
        <h3 class="resume-invalid">{{ $t('dcoResources.invalidProduct') }}</h3>
        <h2 class="resume-invalid">
          {{ $t('dcoResources.invalidProductHelperText') }}
        </h2>
        <div class="mt-8 pt-8">
          <v-card elevation="4">
            <v-row
              class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column flex-wrap"
            >
              <v-col md="8" sm="12">
                <div class="ma-2">
                  <p class="resume-info resume-text">{{ $t('dcoResources.onboardAnotherProduct') }}</p>
                  <p class="resume-helper">
                    {{ $t('dcoResources.onboardAnotherProductHelper') }}
                  </p>
                </div>
              </v-col>
              <v-col
                md="4"
                sm="12"
                class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column flex-wrap align-center"
              >
                <v-btn rounded :color="customCSS['primary']" class="text-none"
                :style="{
                  'font-family': customCSS && customCSS['onboardingBtn-fontFamily'],
                }"
                @click="bankProduct"
                >{{ $t('dcoResources.anotherProduct') }} <BaseIcon name="arrow_forward" :color="customCSS['grey']" iconClass="vertical-alignment"/></v-btn
                >
              </v-col>
            </v-row>
          </v-card>
          <v-card elevation="4" class="mt-8 pt-8">
            <v-row
              class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column flex-wrap"
            >
              <v-col md="8" sm="12">
                <div class="ma-2">
                  <p class="resume-info resume-text">{{ $t('dcoResources.quitApplication') }}</p>
                  <p class="resume-helper">
                    {{ $t('dcoResources.quitHelper') }}
                  </p>
                </div>
              </v-col>
              <v-col
                md="4"
                sm="12"
                class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column flex-wrap align-center"
              >
                <v-btn rounded outlined :color="customCSS['primary']" class="text-none"
                :style="{
                  'font-family': customCSS && customCSS['onboardingBtn-fontFamily'],
                }" @click="quitApplication()"
                  >{{ $t('dcoResources.deleteExit') }}</v-btn
                >
              </v-col>
            </v-row>
          </v-card>
        </div>
      </v-container>
    </v-row>
    <v-row v-if="this.differentLanguage === true">
          <v-dialog v-model="differentLanguage" width="664px" height="100%">
          <v-card class="pa-md-8 mx-lg-auto" align-center justify-center>
            <div class="pa-3 text-center">
            <p class="different-languageModal">{{$t(`dcoResources.differentLanguageEnglish`)}}</p>
            <p class="different-languageModal">{{$t(`dcoResources.differentLanguageArabic`)}}</p>
            </div>
              <v-flex class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column flex-wrapx" style="justify-content: center; padding: 20px;">
              <v-btn
                v-for="(loc, index) in locales"
                :key="loc.code"
                outlined
                class="locale-buttons ma-2"
                :style="{
                  'font-family': customCSS && customCSS['onboardingBtn-fontFamily'],
                }"
                @click="languageSwitch(index)"
              >{{loc.name}}
              </v-btn>
              </v-flex>
          </v-card>
      </v-dialog>
    </v-row>
    <!-- review screen -->
    <v-container class="review-screen overflow-hidden" v-if="currentActionRoute !== undefined">
        <ReviewInformation />
      </v-container>
  </v-container>
</template>

<script>
/* eslint-disable no-unused-expressions */
import FEUIRender from '@feui-render/feui-render';
import CommonService from '@/_core/service/commonService';
import routeMixin from '@/_core/mixins/routeMixin.js';
import appCommonMixin from '@/_core/mixins/appCommonMixin.js';
import rendererMixin from '@/_core/mixins/rendererMixin.js';
import formDataMixin from '@/_core/mixins/formDataMixin.js';
import udfMixin from '@/_core/mixins/udfMixin.js';
import toastMixin from '@/_core/mixins/toastMixin';
import appSettings, { navigationMapping, productItems } from '@/plugins/appSettings';
import store from '@/store';
import * as colors from '@/_core/util/themeUtility';
import { computed } from 'vue';
import Home from '@/components/common/Home.vue';
import urlObj from '@/../_config/_app/apiConfiguration.json';
import event from '@/eventBus.js';
import '@/styles/components/page.scss';
import ReviewInformation from '@/components/common/ReviewInformation.vue';
import { getSupportedLocales, supportedLocaleWithRTLSupport } from '@/plugins/supported-locales';
import BaseIcon from '@/components/common/BaseIcon.vue';
import pageBasedOnProducts from '@/../_config/_app/pageConfigBasedOnProduct.json';

export default {
  name: 'FENG',
  mixins: [routeMixin, appCommonMixin, rendererMixin, toastMixin, formDataMixin, udfMixin],
  components: {
    FEUIRender,
    Home,
    ReviewInformation,
    BaseIcon,
    Modal: () => import('@/components/Modal.vue'),
    toast: () => import('@/components/ErrorHandler/ErrorHandler.vue'),
  },
  // data properties are part of getInitialData
  data() {
    return this.getInitialData();
  },
  provide() {
    const handleUserMessage = {};

    Object.defineProperty(handleUserMessage, 'handleUserMessage', {
      enumerable: true,
      get: () => this.handleUserMessage,
    });
    return {
      parentValue: computed(() => this.parentValue),
      envProperties: computed(() => this.envProperties),
      currentEnvMode: computed(() => this.currentEnvMode),
      udfEnabledForm: computed(() => this.udfEnabledForm),
      messageCount: computed(() => this.messageCount),
      countryCode: computed(
        () => store.getters['userStore/userData']?.userDetails?.countryCode || store.getters['userStore/userData']?.countryCode || 'GBR',
      ),
      cachedFormData: computed(() => store.getters['userStore/userData']?.formData),
      handleUserMessage,
    };
  },
  async created() {
    this.customCSS = colors.colors;
    this.planetImage = this.$appSettings?.dco?.landingScreenImages?.planet !== '' ? require('@/assets/dco/planet.png') : null;
    this.rocketImage = this.$appSettings?.dco?.landingScreenImages?.rocket !== '' ? require('@/assets/dco/rocket.png') : null;
    this.purpleImage = this.$appSettings?.dco?.landingScreenImages?.purpleFlower !== '' ? require('@/assets/dco/purple.png') : null;
    this.pinkImage = this.$appSettings?.dco?.landingScreenImages?.pinkFlower !== '' ? require('@/assets/dco/pink.png') : null;
    this.landingPainter = this.$appSettings?.dco?.landingScreenImages?.landingPainter !== '' ? require('@/assets/dco/landing-painter1.png') : null;
    this.dcoLandingLine = this.$appSettings?.dco?.landingScreenImages?.dcoLandingLine !== '' ? require('@/assets/dco/DCO_Screen_3.png') : null;
    if (this.currentActionRoute === 'productOnboard') {
      this.applicantType = 'primary';
    } else if (this.currentActionRoute === 'secondaryApplicantOnboard') {
      this.applicantType = 'secondary';
    }
    if (!this.dataObj && ['resume', 'eligibilityCheck', 'secondaryEligibilityCheck', 'productOnboard', 'secondaryApplicantOnboard', 'otpVerification', 'otpVerificationProduct'].includes(this.currentActionRoute)
    ) {
      this.dataType = typeof (this.checkRoutePath()
        ? this.navigationMapping[this.currentRoute][this.currentRoute]
        : this.navigationMapping[this.getProductType][this.currentActionRoute]);
      /* Below method is used when navigationMapping contains an action route
        and dependency has been removed for default search action route */
      this.setActionRoute(this.dataType);
      if (store.getters['userStore/userData'].isRefreshToken) {
        this.actionType = this.$route.params.action;
      }
      this.formCode = this.dataType === 'object' ? this.navigationMapping[this.currentRoute][this.currentSubRoute][this.actionType || this.currentActionRoute]
        : this.checkRoutePath() ? this.navigationMapping[this.currentRoute][this.currentRoute] : this.currentActionRoute
          ? this.navigationMapping[this.getProductType][this.currentActionRoute] : this.navigationMapping[this.getProductType][this.currentActionRoute];
      if (store.getters['userStore/userData'] && store.getters['userStore/userData'].userDetails && store.getters['userStore/userData'].userDetails.countryCode) {
        Object.assign(this.formInput, {
          userDetails: {
            countryCode: store.getters['userStore/userData'].userDetails.countryCode,
          },
        });
      }
      this.handleFormUpdate();
    }
    event.$on('errorMessage', (arg1) => {
      if (this.currentActionRoute === 'productOnboard') {
        if (this.formInput.data?.page1?.mobilePhoneNumber !== '' && this.formInput.data?.page1?.mobilePhoneNumber !== undefined) {
          if (arg1 === '') {
            if (this.formInput?.data?.page1?.emailId === '' || this.formInput?.data?.page1?.emailId === undefined) {
              this.dataObj.data.wizardSteps[0].components[3].components[0][0].disabled = true;
            } else if (this.formInput?.data?.page1?.emailId !== '' || this.formInput?.data?.page1?.emailId !== undefined) {
              // this loop is added to pick the regex pattern to validate the email from the schema.
              let emailIdValidation = false;
              // eslint-disable-next-line no-unused-expressions
              this.dataObj && this.dataObj.data && this.dataObj.data.wizardSteps && this.dataObj.data.wizardSteps[0]?.components.forEach((component) => {
                if (component?.key === 'grid') {
                  component && component.components.forEach((subComponent) => {
                    // this loop is added to pick the regex pattern to validate the email from the schema.
                    subComponent.forEach((childComponent) => {
                      if (childComponent?.key === 'emailId') {
                        const emailRegexPattern = new RegExp(childComponent?.validate?.pattern);

                        if (emailRegexPattern) {
                          emailIdValidation = emailRegexPattern.test(this.formInput.data.page1.emailId);
                        }
                      }
                    });
                  });
                }
              });
              if (!emailIdValidation) {
                this.displaySnackBar({ title: this.$t('messages.error'), content: this.$t('messages.invalidEmailId'), type: 'error' });
                this.dataObj.data.wizardSteps[0].components[3].components[0][0].disabled = true;
              } else {
                this.dataObj.data.wizardSteps[0].components[3].components[0][0].disabled = false;
              }
            }
          } else {
            this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: arg1[0], type: 'error' });
            this.mobileNumberValid = false;
            this.dataObj.data.wizardSteps[0].components[3].components[0][0].disabled = true;
          }
        }
      } else if (this.currentActionRoute === 'resume') {
        if (this.formInput?.data?.mobilePhoneNumber !== '' && this.formInput?.data?.mobilePhoneNumber !== undefined) {
          if (arg1 === '') {
            this.dataObj.data.components[4].components[0][0].disabled = false;
          } else {
            this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: arg1[0], type: 'error' });
            this.dataObj.data.components[4].components[0][0].disabled = true;
          }
        }
      }
    });
    event.$on('response', (arg1, arg2) => {
      if (arg1 === 0) {
        // this if condition is added as part of DCO-1118 - To redirect to respective page if application status is not started.
        const applicationStatus = ['CUSTOMER_CREATE_SUBMITTED', 'SECONDARY_CUSTOMER_CREATE_SUBMITTED', 'CUSTOMER_CREATE_SUCCESS_IDV_PENDING',
          'CUSTOMER_CREATE_SUCCESS_IDV_FAILURE', 'CUSTOMER_CREATE_SUCCESS_LISA_REJECTED', 'CUSTOMER_CREATE_SUCCESS_ACCOUNT_PROCEED',
          'CUSTOMER_CREATE_SUCCESS_SECONDARY_CUSTOMER_BLOCKED', 'CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING_SECONDARY_CUSTOMER_BLOCKED', 'SECONDARY_CUSTOMER_CREATE_SUCCESS_WITH_IDV_PENDING', 'SECONDARY_CUSTOMER_CREATE_SUCCESS_WITH_PRIMARY_IDV_PENDING',
          'PRIMARY_SECONDARY_CUSTOMER_CREATE_SUCCESS_WITH_BOTH_IDV_PENDING', 'CUSTOMER_CREATE_FAILED', 'SECONDARY_CUSTOMER_CREATE_FAILED', 'ACCOUNT_CREATE_FAILED',
          'ACCOUNT_CREATE_SUCCESS'];

        if (arg2 && arg2.prospectOnboardingApplication && arg2.prospectOnboardingApplication.applicationStatus && applicationStatus.includes(arg2.prospectOnboardingApplication.applicationStatus)) {
          const additionalInfoData = arg2;

          store.dispatch('userStore/setUserData', {
            additionalInfoData,
          });
          this.$router.push({ params: { action: 'ReviewInformation' } });
        }
        this.response = this.currentActionRoute === 'productOnboard' ? arg2.prospectOnboardingApplication : arg2;
        this.formInput.additionalHelperData = this.$appSettings?.dcoConfigurations?.displayApplicationNumber ? this.response.applicationNumber : '';
        if (this.currentActionRoute === 'productOnboard' && pageBasedOnProducts[this.getProductType][this.applicantType]?.accountInformation !== undefined) {
          this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components.forEach((component) => {
            if (component?.key === 'resendOtpGrid') {
              component && component.components.forEach((subComponent) => {
                subComponent && subComponent.forEach((childComponent) => {
                  if (childComponent?.key === 'button1') {
                    childComponent.action = 'custom';
                  }
                });
              });
            }
          });
          this.formInput.data.page2.b2bSessionId = arg2.b2bSessionId;
          this.formInput.data.page2.initialSavedData = JSON.stringify(arg2.prospectOnboardingApplication); // this is because in 2025.1 we do dedup chek and save data together in one call in server
          if (['savings', 'termDeposit'].includes(this.getProductType) && ['SOLE', 'SINGLE'].includes(this.productData.data.applicableAccountOperationType)) {
            // this loop is added as accountInformation tab should not be clickable when account type is coming as SINGLE from essence.
            const productMapping = store?.getters['userStore/userData']?.productInfo;

            this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType].accountInformation[0]].isClickable = false;
            this.formInput.data.page3.isFromResumeProcess = true;
            this.formInput.data.page3.resumeResponse = JSON.stringify(arg2.prospectOnboardingApplication);
            this.formInput.data.page3.productCode = productMapping?.data?.productCode;
            this.formInput.data.page3.currencyCode = productMapping?.data?.currencyCode;
            this.formInput.data.page3.module = productMapping?.data?.module;
            this.formInput.data.page3.displayProductType = this.getProductType.toLowerCase();
            this.formInput.data.page3.productType = this.apiProductType.toLowerCase();
            this.formInput.data.page3.productTypeCode = this.apiProductType.toLowerCase();
            this.formInput.data.page3.isEndDateCommonForAllAccounts = productMapping?.data?.isEndDateCommonForAllAccounts;
            this.formInput.data.page3.productEndDate = productMapping?.data?.productEndDate;
            this.formInput.data.page3.pageSkipped = true;
            this.formInput.moveToNextPanel = { type: undefined, index: 1 };
          }
          if (['savings', 'termDeposit'].includes(this.getProductType) && ['joint', 'JOINT'].includes(this.productData.data.applicableAccountOperationType)) {
            this.formInput.data.page2.accountOwnership = 'JOINT';
            this.dataObj.data.wizardSteps[1].components.forEach((component) => {
              if (component.key === 'grid1') {
                component && component?.components.forEach((subComponent) => {
                  subComponent?.forEach((childComponent) => {
                    if (childComponent.key === 'accountOwnership') {
                      childComponent.disabled = 'true';
                    }
                  });
                });
              } else if (component?.key === 'accountOwner') {
                component.hidden = false;
                component && component?.components.forEach((subComponent) => {
                  subComponent?.forEach((childComponent) => {
                    childComponent.hidden = false;
                  });
                });
              }
            });
          }
        } else {
          if (this.currentActionRoute === 'secondaryApplicantOnboard') {
            this.formInput.data.page2.partiallySavedData = JSON.stringify(arg2);
            this.formInput.data.page2.displayProductType = this.getProductType?.toLowerCase();
          }
        }
        this.updateDataObjects(this.response, pageBasedOnProducts, arg2);
      } else if (arg1 === 1) {
        if (this.currentActionRoute === 'productOnboard' && pageBasedOnProducts[this.getProductType][this.applicantType]?.accountInformation !== undefined) {
          this.response = arg2;
          this.updateDataObjects(this.response, pageBasedOnProducts, arg2);
        } else {
          const personalInformationData = arg2;

          store.dispatch('userStore/setUserData', {
            personalInformationData,
          });
        }

        this.formInput.additionalHelperData = this.$appSettings?.dcoConfigurations?.displayApplicationNumber ? this.response.applicationNumber : '';
      } else if (arg1 === 2) {
        const personalInformationData = arg2;

        store.dispatch('userStore/setUserData', {
          personalInformationData,
        });

        this.formInput.additionalHelperData = this.$appSettings?.dcoConfigurations?.displayApplicationNumber ? this.response.applicationNumber : '';
        this.formInput.data[this.additionalInformationPage].b2bSessionId = personalInformationData.b2bSessionId;
      }
      if (this.saveExit === true) {
        this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.saveSuccess'), type: 'Success' });
        const redirectTimeout = this.$appSettings?.dco?.redirectTimeout;

        setTimeout(function() {
          window.location.href = appSettings.dco.bankProductPage;
        }, redirectTimeout);
      }
    });
    event.$on('actionType', (arg1, arg2) => {
      if (arg1 === 1 && arg2 === 'saveExit') {
        this.saveExit = true;
      } else if (arg1 === 2 && (arg2 === 'saveExit' || arg2 === undefined)) {
        if (this.currentActionRoute === 'productOnboard' && pageBasedOnProducts[this.getProductType][this.applicantType]?.accountInformation !== undefined) {
          if (arg2 === 'saveExit') {
            this.saveExit = true;
          }
        } else {
          if (this.currentActionRoute === 'secondaryApplicantOnboard') {
            this.updateSecondaryApplicantData(arg2);
          } else {
            this.reviewInfo(arg2);
          }
        }
      } else if (this.currentActionRoute === 'productOnboard' && arg1 === 3 && arg2 !== 'deleteExit') {
        this.reviewInfo(arg2);
      } else if (arg2 === 'deleteExit') {
        if ((arg1 === 1 || arg1 === 2 || arg1 === 3)) {
          this.deleteData(arg1);
        }
      }
    });
    event.$on('configKey', (arg1) => {
      this.resumeCount = this.resumeCount + 1;
      if (arg1.data.isDocumentUploaded) {
        if (this.profileImage && this.profileImage.data && this.profileImage.data.length !== 0 && this.formInput.data[this.personalInformationPage].photoEntityId !== '' && this.identityDocuments.data.length > 0) {
          for (let index = 0; index < this.identityDocuments.data.length; index++) {
            if (this.identityDocuments.data[index].documentSubCategoryId === 'E1F9C80B-22D4-4E1B-B07A-238F6FA58FB7' && (arg1.data.key !== 'passportDocument') && (this.resumeCount === 1 || this.identityDocuments.data.length === 2)) {
              this.formInput.resumeFileUpload = {
                document: true,
                key: 'passportDocument',
                value: {
                  name: this.identityDocuments.data[index].documentName,
                  type: this.identityDocuments.data[index].documentType,
                },
                response: this.identityDocuments.data[index],
              };
              break;
            } else if (this.identityDocuments.data[index].documentSubCategoryId === 'E2F1110B-11D4-4E1B-B07A-238F6FA58FB7' && (arg1.data.key !== 'drivingLicenseDocument') && (this.resumeCount <= 2 || this.identityDocuments.data.length === 1)) {
              this.formInput.resumeFileUpload = {
                document: true,
                key: 'drivingLicenseDocument',
                value: {
                  name: this.identityDocuments.data[index].documentName,
                  type: this.identityDocuments.data[index].documentType,
                },
                response: this.identityDocuments.data[index],
              };
              break;
            } else if (this.identityDocuments.data[index].documentSubCategoryId === 'E2F1280B-23D4-4E1B-B07A-238F6FA58FB7' && (arg1.data.key !== 'nationalInsuranceDocument') && this.formInput.data[this.personalInformationPage].nationalInsuranceEntityId === '') {
              this.formInput.resumeFileUpload = {
                document: true,
                key: 'nationalInsuranceDocument',
                value: {
                  name: this.identityDocuments.data[index].documentName,
                  type: this.identityDocuments.data[index].documentType,
                },
                response: this.identityDocuments.data[index],
              };
            }
          }
        } else if (this.profileImage.data.length > 0) {
          this.formInput.resumeFileUpload = {
            document: true,
            key: 'photoDocument',
            value: {
              name: this.profileImage.data[0].documentName,
              type: this.profileImage.data[0].documentType,
            },
            response: this.profileImage.data[0],
          };
        }
      }
    });
    event.$on('cancel', (arg1) => {
      this.formInput.data[this.personalInformationPage].nationalIdNumber = '';
      this.formInput.data[this.personalInformationPage] = Object.assign(
        {},
        {
          ...this.formInput.data[this.personalInformationPage],
          ...{
            nationalIdNumber: '',
          },
        },
      );
      this.$forceUpdate();
    });
    event.$on('clearSecondaryApplicantData', (arg1) => {
      const data = localStorage.getItem('additionalInfoData');

      this.deleteSecondaryApplicantData(data);
    });
    event.$on('changeAccountOwnership', (arg1) => {
      const data = localStorage.getItem('additionalInfoData');

      this.updateAccountOwnership(data);
    });

    event.$on('redirectToAccountInformation', async(arg1) => {
      localStorage.getItem('additionalInfoData');
      const data = JSON.parse(localStorage.getItem('additionalInfoData'));
      const otherInformation = JSON.parse(data.otherInformation);
      const statusInformation = JSON.parse(data.statusInformation);
      const productMapping = store.getters['userStore/userData'].productInfo;
      const b2bSessionId = this.formInput.data.b2bSessionId;

      const profileImage = await CommonService.getDocumentUpload(`${urlObj.getUpload}/${data.entityId}/${'FECO_PROOF_CATEGORY_PHOTO'}/${'Primary'}`, { b2bSessionId: b2bSessionId });
      const identityDocuments = await CommonService.getDocumentUpload(`${urlObj.getUpload}/${data.entityId}/${'FECO_PROOF_CATEGORY_IDENTITY'}/${'Primary'}`, { b2bSessionId: b2bSessionId });

      let productInformation = data.productInformation;
      productInformation = JSON.stringify({
        productTypeCode: this.apiProductType.toLowerCase(),
        productId: this.getProductCode,
        accountOwnership: '',
        modeOfOperation: '',
        tenorFrequency: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 'MONTH' : '' : '',
        tenorValue: productMapping?.data?.isEndDateCommonForAllAccounts === null || productMapping?.data?.isEndDateCommonForAllAccounts === undefined || productMapping?.data?.isEndDateCommonForAllAccounts === false ? this.apiProductType === 'termdeposit' ? 1 : '' : '',
        interestRate: '',
        postingRestriction: '',
        currencyCode: productInformation?.currencyCode,
        maturityInstruction: '',
        module: productMapping?.data.module,
        purposeOfAccount: productInformation?.purposeOfAccount || '',
        purposeOfAccountOthers: productInformation?.purposeOfAccountOthers || '',
        expectedUsage: productInformation?.expectedUsage || '',
        purposeOfAccountDescription: productInformation?.purposeOfAccountDescription || '',
        expectedUsageDescription: productInformation?.expectedUsageDescription || '',
        productEndDate: productMapping?.data?.productEndDate,
        isEndDateCommonForAllAccounts: productMapping?.data?.isEndDateCommonForAllAccounts,
        productSubType: this.getProductType || '',
      });
      data.productInformation = productInformation;
      data.contactInformation = null;
      data.personalInformation = null;
      data.taxInformation = null;
      data.accountInformation = null;
      data.otherInformation = otherInformation ? JSON.stringify({
        addressLookupEnabled: otherInformation.addressLookupEnabled || null,
        lisaTransferInWithAgeValidation: otherInformation.lisaTransferInWithAgeValidation || null,
      }) : null;
      data.statusInformation = profileImage?.data?.length > 0 || identityDocuments?.data?.length > 0 ? JSON.stringify({
        identityVerificationEnabled: false,
      }) : statusInformation ? JSON.stringify({
        identityVerificationEnabled: statusInformation.identityVerificationEnabled,
      }) : null;
      localStorage.setItem('additionalInfoData', JSON.stringify(data));
      this.changedProduct = true;
      this.$router.push({ params: { action: 'productOnboard' }, query: { type: 'AccountInformation' } });
    });

    // check Locale if exists
    const localeSelected = localStorage.getItem('localeSelected');

    if (localeSelected && this.locales.length >= 2 && this.currentActionRoute !== 'customerOnboarding') {
      const localeMesg = await CommonService.getLocaleData(localeSelected);

      this.$vuetify.rtl = !!this.isRTL.includes(localeSelected);
      this.$i18n.locale = localeSelected;
      this.$i18n.setLocaleMessage(localeSelected, localeMesg[localeMesg.lang]);
      this.language = localeSelected;
    }
  },
  mounted() {
    this.doAPiCall();
    if (this.currentActionRoute === 'customerOnboarding' || this.currentActionRoute === 'resume') {
      window.onpopstate = function() {
        location.reload();
      };
    }
    if (this.currentActionRoute === 'customerOnboarding' || this.currentActionRoute === 'resume') {
      // reset the locale informations
      localStorage.setItem('localeSelected', 'en_GB');
      this.$vuetify.ltr = true;
      this.$vuetify.rtl = !!this.isRTL.includes('en_GB');
      this.$i18n.locale = 'en_GB';
      this.language = 'en_GB';
    }
    if (this.currentActionRoute === 'productOnboard') {
      this.applicantType = 'primary';
    } else if (this.currentActionRoute === 'secondaryApplicantOnboard') {
      this.applicantType = 'secondary';
    }
    this.personalInformationPage = this.getProductType && pageBasedOnProducts ? pageBasedOnProducts[this.getProductType][this.applicantType].personalInformation[1] : '';
    this.additionalInformationPage = this.getProductType && pageBasedOnProducts ? pageBasedOnProducts[this.getProductType][this.applicantType].additionalInformation[1] : '';
    if (this.currentActionRoute !== 'otpVerification' && this.currentActionRoute !== 'otpVerificationProduct') {
      Object.keys(localStorage).forEach((key) => {
        if (key !== 'localeSelected') {
          localStorage.removeItem(key);
        }
      });
    }
  },
  methods: {
    getInitialData() {
      return {
        customCSS: {},
        navigationMapping: navigationMapping.navigationMapping,
        formComponents: [],
        componentKey: 'page',
        modalComponentKey: 'modal',
        formCode: '',
        modalFormCode: '',
        dataObj: undefined,
        formInput: {
          config: '',
          data: '',
          userDetails: '',
          'support-data': {},
          moveToNextPanel: {},
          additionalHelperData: '',
          searchFilter: {},
          resumeFileUpload: {},
        },
        modalFormInput: { config: '', data: {}, userDetails: '', 'support-data': {} },
        formPublishState: false,
        formActionData: {},
        modalConfig: {
          enabled: false,
          icon: '',
          persistent: true,
          close: false,
          title: '',
          width: '',
          content: '',
          saveButton: 'OK',
          cancelButton: '',
          customToolBar: false,
          hideToolbar: true,
          rounded: false,
          enableSaveButton: false,
        },
        dataType: '',
        actionType: '',
        rendererModal: false,
        modelDataObj: {},
        parentValue: '',
        envProperties: '',
        currentEnvMode: '',
        udfEnabledForm: false,
        isAlertVisibile: true,
        tempFormInput: {},
        toggleEnabled: false,
        dataNotFound: false,
        dialog: false,
        isClicked: false,
        isToggled: false,
        productData: {
          data: {
            productDescription: '',
            productName: '',
          },
          status: '',
        },
        invalidProductCode: false,
        productSame: true,
        response: {
          entityId: '',
        },
        localeToggle: 0,
        locales: getSupportedLocales(),
        isRTL: supportedLocaleWithRTLSupport(),
        localeDialog: false,
        previousExpired: false,
        resumeContactInformation: '',
        resumePersonalInformation: '',
        resumeTaxInformation: '',
        count: 0,
        language: '',
        differentLanguage: false,
        saveResponse: '',
        localeSet: '',
        ebavCount: 0,
        accountVerified: false,
        productType: '',
        productItems,
        productTypes: this.$appSettings.dcoConfigurations.productTypes,
        apiProductType: '',
        cachedFormData: '',
        messageCount: '',
        profileImage: '',
        drivingLicenseImage: '',
        nationalInsuranceCardImage: '',
        identityDocuments: [],
        isFromResumeProcess: false,
        resumeCount: 0,
        uploadedIndex: 0,
        lisaEligibilityPassed: false,
        mobileNumberValid: '',
        isTransferInValidationNeeded: false,
        index: 0,
        documentIndex: 0,
        applicantType: 'primary',
        IDVForSecondaryApplicant: false,
        changedProduct: false,
        planetImage: '',
        rocketImage: '',
        purpleImage: '',
        pinkImage: '',
        landingPainter: '',
        dcoLandingLine: '',
        resumeProductType: '',
      };
    },
    createNewForm() {
      this.$router.push({ params: { action: 'view', id: 'new', pid: 'add' } });
    },
    panelErrorMessage(e) {
      this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: `${this.$t('messages.save.error.form')}`, type: 'error' });
    },
    panelApiCallMessage(e) {
      if (!e.isMessageConfigured) {
        if (e.success) {
          this.displaySnackBar({ title: `${this.$t('messages.data.success')}`, content: this.$t('messages.save.apiSuccess'), type: 'success' });
        } else {
          this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: this.$t('messages.save.apiFailure'), type: 'error' });
        }
      }
    },
    onCancel() {
      this.$refs.renderForm.reset();
    },
    onReset(e) {
      // assign initialDefaultValues to a dataProperty
      this.tempFormInput = e;
      this.$refs.renderForm.reset();
    },
    dataFunction() {
      this.dataNotFound = false;
      this.$router.push({ params: { action: 'resume' } });
    },
    async onToggle(e) {
      if (e.state === true) {
        if (e.key === 'read') {
          this.toggleEnabled = true;
          e.state === false;
        }
      }
    },
    async onUpdateFormInfo(e) {
      this.formInput.data.fileEntityId = this.formInput.data[this.additionalInformationPage].fileEntityId;
      this.formInput.data.photoEntityId = this.formInput.data[this.personalInformationPage].photoEntityId;
      this.formInput.data.passportEntityId = this.formInput.data[this.personalInformationPage].passportEntityId;
      this.formInput.data.drivingLicenseEntityId = this.formInput.data[this.personalInformationPage].drivingLicenseEntityId;
      this.formInput.data.nationalInsuranceEntityId = this.formInput.data[this.personalInformationPage].nationalInsuranceEntityId;
      if (this.$appSettings.dcoConfigurations.productsAllowedWithAccountDetails.includes(this.getProductType)) {
        const wizardStep = pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[0];

        this.dataObj && this.dataObj.data && this.dataObj.data.wizardSteps && this.dataObj.data.wizardSteps[wizardStep] && this.dataObj.data.wizardSteps[wizardStep].components && this.dataObj.data.wizardSteps[wizardStep].components.forEach((component) => {
          if (component.key === 'searchGrid') {
            for (let index = 0; index < component.components.length; index++) {
              component.components[index].forEach((subComponent) => {
                if (subComponent.key === 'confirmSortCode') {
                  subComponent.hidden = false;
                } else if (subComponent.key === 'searchSortCode') {
                  subComponent.hidden = true;
                }
              });
            }
          }
        });
      }
      this.$forceUpdate();
    },
    async onAction({ action,
      item,
      value,
      schema,
      key,
      targetKey,
      stepName,
      buttonResponse,
      isButtonFormPopUp,
      mapBackToParentObj }) {
      if ((this.dataObj.data.wizardSteps && this.dataObj.data.wizardSteps.length > 0) && (action?.name === 'hideGrid') &&
      ((this.formInput.data && this.formInput.data[this.personalInformationPage] && this.formInput.data[this.personalInformationPage].applicationStatus !== undefined && this.formInput.data[this.personalInformationPage].applicationStatus !== '') ||
      (this.formInput.data && this.formInput.data[this.personalInformationPage] && this.formInput.data[this.personalInformationPage].resumeResponse !== undefined && this.formInput.data[this.personalInformationPage].resumeResponse !== ''))) {
        return null;
      } else {
        if (action?.action === 'view' || action?.action === 'viewOnly') {
          let { redirectPath } = action;
          const regx = /\{{([^}}]+)\}}/g;
          const urlParams = redirectPath.matchAll(regx);

          if (urlParams) {
            for (const data of urlParams) {
              redirectPath = redirectPath.replace(data[0], item[data[1]]);
            }
          }
          this.formActionData = JSON.parse(
            JSON.stringify({
              ...action,
              item,
            }),
          );
          this.$router.push(redirectPath);
        } else if (action === 'textWithSearch') {
          const stepFormData = this.formInput.data[stepName];
          const route = this.$route.params;
          let response = await CommonService.getFormSchemaFromLocal(schema.buttonForm.toLowerCase());

          if (!response?.data) {
            response = await CommonService.getFormSchemaFromLocal(schema.buttonForm);
          }
          this.modalConfig.enabled = true;
          this.rendererModal = true;
          // This is to fetch custom mappings that is needed if dataTable item keys and formInputdata keys are different.
          this.customProperties = schema?.properties?.customProperties;
          /* This assignment has been captured for datatable in renderer */
          Object.assign(response, {
            ...response,
            data: {
              ...response.data,
              rendererModal: this.rendererModal,
            },
          });
          // Fetches mapping properties from parent Form to text with search popup
          const mapFieldsFromParentToTextWithSearch = (schema && schema.mapFieldsFromParentToTextWithSearch) || false;
          const mapFieldsFromParentToTextWithSearchList = (schema && schema.mapFieldsFromParentToTextWithSearchList) || [];

          this.modalFormInput = Object.assign(this.modalFormInput, {
            pagination: '',
          });
          this.modalConfig.content = '';
          this.modelDataObj = response;
          this.modalConfig.close = true;
          this.modalFormCode = response?.data?.entityCode;
          this.modalConfig.title = this.$t(
          `formStaticValue.${this.modalFormCode}.textWithSearchPopupChildFormTitle`,
          );
          this.modalConfig.width = 850;
          this.modalConfig.rounded = true;
          this.modalConfig.hideToolbar = true;
          this.modalConfig.enableSaveButton = false;
          this.modalConfig.saveButton = this.$t(`formStaticValue.${this.modalFormCode}.save`);
          this.modalConfig.cancelButton = this.$t(`formStaticValue.${this.modalFormCode}.cancel`);
          this.modalConfig.cancelCallback = () => {
            this.modelDataObj = {};
          };
          this.modalConfig.saveCallback = () => {
            this.modelDataObj = {};
          };
          this.parentValue = { schema: schema, value, stepFormData, route, formData: this.formInput.data, mapFieldsFromParentToTextWithSearch, mapFieldsFromParentToTextWithSearchList };
        } else if (action === 'formPopUp') {
          let response = await CommonService.getFormSchemaFromLocal(schema.buttonForm.toLowerCase());

          if (!response?.data) {
            response = await CommonService.getFormSchemaFromLocal(schema.buttonForm);
          }
          this.modalConfig.enabled = true;
          this.rendererModal = true;
          /* This assignment has been captured for differentiating button form pop-up with text with search pop-up */
          Object.assign(response, {
            ...response,
            data: {
              ...response.data,
              isButtonFormPopUp: true,
            },
          });
          this.modalConfig.content = '';
          this.modelDataObj = response;
          this.modalFormCode = response?.data?.entityCode;
          this.modalConfig.cancelButton = false;
          this.modalConfig.saveButton = false;
          this.modalConfig.customToolBar = true;
          this.modalConfig.close = true;
          this.modalConfig.title = this.$t(
          `formStaticValue.${this.modalFormCode}.onButtonPopupFormTitle`,
          );
          this.modalConfig.width = 650;
          this.parentValue = { buttonResponse };
          this.modalConfig.enableSaveButton = false;
          this.modalConfig.customPopup = false;
          this.modelConfig.customPopupTitle = this.$t(`formStaticValue.${this.modalFormCode}.customPopupTitle`);
          this.modelConfig.customPopupContent = this.$t(`formStaticValue.${this.modalFormCode}.customPopupContent`);
          const { parentToChildMap = false, parentToChildMapProperties } = schema;

          if (
            parentToChildMap &&
          parentToChildMapProperties &&
          parentToChildMapProperties.length > 0
          ) {
            if (this.parentValue && this.parentValue.buttonResponse === '') {
              this.parentValue.buttonResponse = {};
            }
            if (stepName) {
              parentToChildMapProperties.forEach((item) => {
                this.parentValue.buttonResponse[item.childKey] =
                this.formInput.data[stepName][item.parentKey];
              });
            } else {
              parentToChildMapProperties.forEach((item) => {
                this.parentValue.buttonResponse[item.childKey] = this.formInput.data[item.parentKey];
              });
            }
          }
        } else if (action === 'modalPopupAction') {
          if (isButtonFormPopUp && this.modalConfig.enabled) {
            this.modalConfig.enabled = false;
          }
        } else if (action === 'rowClick') {
          this.modalConfig.enableSaveButton = true;
          this.modalConfig.saveCallback = () => {
            const wizardSteps = this.dataObj?.data?.wizardSteps;
            let count = 0;

            if (wizardSteps.length) {
              wizardSteps.forEach((step) => {
                for (const [key, value] of Object.entries(item)) {
                  for (const [componentKey] of Object.entries(this.formInput?.data[step.name])) {
                    if (componentKey === key) {
                      count++;
                      this.formInput.data[step.name][componentKey] = value;
                      if (count === 1) {
                        this.$route.params.keyToMap = componentKey;
                      }
                    }
                  }
                }
                if (this.customProperties && this.customProperties.length > 0) {
                  this.customProperties.forEach((data) => {
                    if (data.key && data.value && step.name && (this.formInput?.data[step.name] && (data.key in this.formInput.data[step.name])) && item[data.value]) {
                      this.updateAddressDetails(data.key, item);
                      this.formInput.data[step.name][data.key] = item[data.value];
                    }
                  });
                }
                this.parentFormValueUpdate = true;
              });
            } else {
              for (const [key, value] of Object.entries(item)) {
                for (const [componentKey] of Object.entries(this.formInput?.data)) {
                  if (componentKey === key) {
                    this.formInput.data[componentKey] = value;
                  }
                }
              }
              this.parentFormValueUpdate = true;
              if (this.customProperties && this.customProperties.length > 0) {
                this.customProperties.forEach((data) => {
                  if (data.key && data.value && (data.key in this.formInput.data) && item[data.value]) {
                    this.formInput.data[data.key] = item[data.value];
                  }
                });
              }
            }
            this.modelDataObj = {};
          };
        } else if (action?.action === 'itemSelected' && this.modalConfig.enabled) {
          this.modalConfig.saveCallback = () => {
            const wizardSteps = this.dataObj?.data?.wizardSteps;
            let count = 0;

            if (wizardSteps.length) {
              wizardSteps.forEach((step) => {
                for (const [key, value] of Object.entries(item)) {
                  for (const [componentKey] of Object.entries(this.formInput?.data[step.name])) {
                    if (componentKey === key) {
                      count++;
                      this.formInput.data[step.name][componentKey] = value;
                      if (count === 1) {
                        this.$route.params.keyToMap = componentKey;
                      }
                    }
                  }
                }
                if (this.customProperties && this.customProperties.length > 0) {
                  this.customProperties.forEach((data) => {
                    if (data.key && data.value && step.name && (this.formInput?.data[step.name] && (data.key in this.formInput.data[step.name])) && item[data.value]) {
                      this.formInput.data[step.name][data.key] = item[data.value];
                    }
                  });
                }
                this.parentFormValueUpdate = true;
              });
            } else {
              for (const [key, value] of Object.entries(item)) {
                if (typeof value === 'object') {
                  Object.values(value).forEach((nestedValue) => {
                    nestedValue.forEach((item) => {
                      Object.keys(item).forEach((subNestedkey) => {
                        for (const [componentKey] of Object.entries(this.formInput?.data)) {
                          if (componentKey === subNestedkey) {
                            this.formInput.data[componentKey] = item[subNestedkey];
                          }
                        }
                      });
                    });
                  });
                } else {
                  for (const [componentKey] of Object.entries(this.formInput?.data)) {
                    if (componentKey === key) {
                      this.formInput.data[componentKey] = value;
                    }
                  }
                }
              }
              this.parentFormValueUpdate = true;
              if (this.customProperties && this.customProperties.length > 0) {
                this.customProperties.forEach((data) => {
                  if (data.key && data.value && (data.key in this.formInput.data) && item[data.value]) {
                    this.formInput.data[data.key] = item[data.value];
                  }
                });
              }
            }
            this.modelDataObj = {};
          };
        } else if (action?.action === 'itemSelected' || action === 'itemSelected') {
          const cachedDataInStore = store.getters['userStore/userData'].formData || {};
          const { [key]: changedValue, ...unchangedCache } = cachedDataInStore;
          const dataToBeCached = Object.assign({}, unchangedCache, item);

          store.dispatch('userStore/setUserData', {
            formData: dataToBeCached,
          });
        } else if (action?.action === 'copySelectedItem' && targetKey && targetKey.componentKey) { // This condition is to handle copy data table on row selection
          if (targetKey.stepName && this.formInput && this.formInput.data && this.formInput.data[targetKey.stepName] && this.formInput.data[targetKey.stepName][targetKey.componentKey]) {
            this.formInput.data[targetKey.stepName][targetKey.componentKey] = item;
          } else if (this.formInput && this.formInput.data && this.formInput.data[targetKey.componentKey]) {
            this.formInput.data[targetKey.componentKey] = item;
          }
        } else if (action?.action === 'pdf') {
          if (action.updateDataSource) {
            let url = action.datasourceUrl;

            // Update path params value in the URL
            const regx = /{{[a-zA-Z]*}}/g;
            const datasourceUrlParams = url.match(regx);
          datasourceUrlParams?.shift(); // remove first field because, it is baseURL (feus,fesd,etc)

          if (action.type === 'btn') {
            const wizardSteps = this.dataObj?.data?.wizardSteps;

            if (wizardSteps.length) {
              datasourceUrlParams.forEach((param) => {
                const paramString = param.substring(2, param.length - 2);
                const paramRegx = new RegExp(`{{${paramString}}}`);
                const paramValue = this.fetchWizardItemValue(paramString);

                if (paramValue) {
                  url = url.replace(paramRegx, paramValue);
                }
              });
            } else {
              datasourceUrlParams.forEach((param) => {
                const paramString = param.substring(2, param.length - 2);
                const paramRegx = new RegExp(`{{${paramString}}}`);
                url = url.replace(paramRegx, this.formInput.data[paramString]);
              });
            }
          } else {
            if (datasourceUrlParams && datasourceUrlParams.length) {
              datasourceUrlParams.forEach((param) => {
                const paramString = param.substring(2, param.length - 2);
                const paramRegx = new RegExp(`{{${paramString}}}`);

                url = url.replace(paramRegx, item[paramString]);
              });
            }
          }
          const { messageMetaData: { messageProperties } = {} } = action;
          const messageStatusCodeList = [];
          let enocdedBase64String;

          if (messageProperties?.length > 0) {
            messageProperties.forEach((property) => {
              messageStatusCodeList.push(property.messageStatusCode);
            });
          }
          //  fetch encoded base64string from resposne
          const saveResponse = await CommonService.getWebHookSearchResults(
            url,
            {},
            0,
            10,
            messageStatusCodeList,
          );

          if (messageProperties?.length > 0) {
            this.handleUserMessage(messageProperties, saveResponse);
            store.dispatch('appStore/setAppData', {
              inProgress: false,
            });
          }
          if (saveResponse && saveResponse.status === 200) {
            enocdedBase64String = action.base64ResponseKey
              ? this.findNestedObjectPropertyValue(action.base64ResponseKey, saveResponse.data)
              : saveResponse.data;
            // convert base64string to bloburl
            if (enocdedBase64String) {
              this.createBlobUrl(enocdedBase64String, action.action);
            } else {
              this.displaySnackBar({
                title: `${this.$t('messages.error')}`,
                content: this.$t('messages.save.error.noKey.pdf'),
                type: 'error',
              });
            }
          }
          }
        } else if (action?.action === 'download') {
          if (action.updateDataSource) {
            let url = action.datasourceUrl;

            // Update path params value in the URL
            const regx = /{{[a-zA-Z]*}}/g;
            const datasourceUrlParams = url.match(regx);
          datasourceUrlParams?.shift(); // remove first field because, it is baseURL (feus,fesd,etc)

          if (datasourceUrlParams && datasourceUrlParams.length) {
            datasourceUrlParams.forEach((param) => {
              const paramString = param.substring(2, param.length - 2);
              const paramRegx = new RegExp(`{{${paramString}}}`);
              url = url.replace(paramRegx, item[paramString]);
            });
          }
          //  fetch encoded base64string from resposne
          const saveResponse = await CommonService.getWebHookSearchResults(url, {}, 0, 10);
          const enocdedBase64String = action.base64ResponseKey
            ? this.findNestedObjectPropertyValue(action.base64ResponseKey, saveResponse.data)
            : saveResponse.data;
          const documentName = action.documentNameKey
            ? this.findNestedObjectPropertyValue(action.documentNameKey, saveResponse.data)
            : '';

          // convert base64string to bloburl and download
          if (enocdedBase64String) {
            this.createBlobUrl(enocdedBase64String, action.action, documentName);
          } else {
            this.displaySnackBar({
              title: `${this.$t('messages.error')}`,
              content: this.$t('messages.save.error.noKey.download'),
              type: 'error',
            });
          }
          }
        } else if (action?.action === 'preview') {
          if (action.updateDataSource) {
            let url = action.datasourceUrl;

            // Update path params value in the URL
            const regx = /{{[a-zA-Z]*}}/g;
            const datasourceUrlParams = url.match(regx);
          datasourceUrlParams?.shift(); // remove first field because, it is baseURL (feus,fesd,etc)

          if (datasourceUrlParams && datasourceUrlParams.length) {
            datasourceUrlParams.forEach((param) => {
              const paramString = param.substring(2, param.length - 2);
              const paramRegx = new RegExp(`{{${paramString}}}`);
              url = url.replace(paramRegx, item[paramString]);
            });
          }
          //  fetch encoded base64string from resposne
          const saveResponse = await CommonService.getWebHookSearchResults(url, {}, 0, 10);
          const enocdedBase64String = action.base64ResponseKey
            ? this.findNestedObjectPropertyValue(action.base64ResponseKey, saveResponse.data)
            : saveResponse.data;

          // convert base64string to bloburl and download
          if (enocdedBase64String) {
            this.createBlobUrl(enocdedBase64String, action.action);
            this.pdfmodalConfig.enabled = this.pdfmodalConfig.pdfLoading = true;
          } else {
            this.displaySnackBar({
              title: `${this.$t('messages.error')}`,
              content: this.$t('messages.save.error.noKey.preview'),
              type: 'error',
            });
          }
          }
        } else if (action === 'apiCallRequestMade') {
          this.numberOfApiCallRequestsMadeInRenderer += value;
        } else if (action === 'apiCallResponseRetrieved') {
          this.numberOfApiCallResponseRetrievedInRenderer += value;
        } else if (action?.action === 'custom' && action.name === 'delete') {
          store.dispatch('appStore/setAppData', {
            message: {
              content: this.$t('messages.delete.message'),
              type: 'error',
              component: 'modal',
              title: this.$t('messages.delete.title'),
              saveButton: this.$t('messages.delete.saveButton'),
              close: true,
              saveCallback: this.proceedWithDelete,
              persistent: true,
              deletePopup: true,
            },
          });
        } else if (action === 'redirectTo') {
        // console.log('Write your application specific redirect action here!');
        } else if (action === 'mapBackToParent') {
        // This action is to map back fields from child form to parent Form after button Form action.
          if (this.modalConfig.enabled) {
            this.modelDataObj = this.getInitialData().modelDataObj;
            this.modalConfig = { // Resetting modal pop-up config to remove stale data
              enabled: false,
              icon: '',
              persistent: true,
              close: false,
              title: '',
              width: '',
              content: '',
              saveButton: 'OK',
              cancelButton: 'Cancel',
              customToolBar: false,
            };
            if (mapBackToParentObj && Object.keys(mapBackToParentObj) && Object.keys(mapBackToParentObj).length > 0) {
              this.formInput = Object.assign(
                {},
                {
                  ...this.formInput,
                  data: {
                    ...this.formInput.data,
                    ...mapBackToParentObj,
                  },
                },
              );
            }
          }
          store.dispatch('appStore/setAppData', {
            message: {
              content: this.$t('messages.delete.message'),
              type: 'error',
              component: 'modal',
              title: this.$t('messages.delete.title'),
              saveButton: this.$t('messages.delete.saveButton'),
              close: true,
              saveCallback: this.proceedWithDelete,
              persistent: true,
              deletePopup: true,
            },
          });
        } else if (action?.name === 'continue') {
          const countryCode = this.formInput.data.mobileCountryCode;
          const phoneNumber = this.formInput.data.mobilePhoneNumber;

          this.productCompareNumber = phoneNumber;
          this.productCompareCode = countryCode;
          const mobile = {
            mobilePhoneNumber: phoneNumber,
            mobileCountryCode: countryCode,
          };

          localStorage.setItem('mobileNumber', JSON.stringify(mobile));
          store.dispatch('userStore/setUserData', {
            mobileNumber: mobile,
          });
          const response = await CommonService.productValidation(urlObj.productValidation, {
            mobileCountryCode: countryCode,
            mobilePhoneNumber: phoneNumber,
            emailId: null,
            productType: this.apiProductType.toLowerCase(),
            productCode: this.getProductCode,
          });

          this.productCompareResponse = response;
          localStorage.setItem('productValidationResponse', JSON.stringify(response));
          if (
          response.data?.causes[0]?.message.includes('There is no data available for the entered Mobile Number.') || this.$appSettings?.errorCodes?.includes(response.data?.causes[0]?.code)
          ) {
            this.dataNotFound = true;
          } else if (this.$appSettings?.errorCodes?.includes(response.data?.causes[0]?.code) ||
          response.data?.causes[0]?.message.includes('Invalid product information. Failed to fetch product details') || response.data?.causes[0]?.message.includes('Your previously chosen product is no longer available or invalid.')
          ) {
            this.invalidProductCode = true;
          } else if (response.isDifferentFromExistingProduct === false) {
            const status = await CommonService.sendOTP(urlObj.sendOTP, {
              mobileCountryCode: countryCode,
              mobilePhoneNumber: phoneNumber,
            });

            if (status && [400, 401, 403, 404, 413, 429, 500, 503].includes(status?.status)) {
              this.displaySnackBar({ title: status?.data?.title, content: status?.data?.causes[0].message, type: 'error' });
            } else {
              const b2bSessionId = status?.b2bSessionId;

              store.dispatch('userStore/setUserData', {
                b2bSessionId,
              });
              localStorage.setItem('referenceCode', status.referenceCode);
              this.$router.push({ params: { action: 'otpVerification' } });
            }
          } else if (response.isDifferentFromExistingProduct === true) {
            if (this.formInput?.data?.mobileCountryCode !== '+44') {
              const countryData = window.intlTelInputGlobals.getCountryData();
              const countryCode = (countryData.find((data) => data.dialCode === this.formInput?.data?.mobileCountryCode.replace('+', '')))?.iso2;

              store.dispatch('userStore/setUserData', {
                countryCode,
              });
            }
            if (this.$appSettings?.errorCodes?.includes(response.data?.causes[0]?.code) || (response.productDetails[1]?.errorMessage !== null &&
            response.productDetails[1]?.errorMessage.includes('Your previously chosen product is no longer available or invalid')
            )) {
              this.dataObj.data.components[3].components[0][0].productCard.cardExpire =
              response.productDetails[1].expiredOrInvalidProduct;
              this.previousExpired = true;
            }
            this.productSame = false;
            this.dataObj.data.components[2].hidden = false;
            this.dataObj.data.components[3].hidden = false;
            this.dataObj.data.components[0].hidden = true;
            this.dataObj.data.components[4].hidden = true;
            this.dataObj.data.components[5].hidden = false;
            this.dataObj.data.components[1].components[0][0].hidden = true;
            this.dataObj.data.components[2].components[0][0].productCard.cardTitle1Value =
            response.productDetails[0].productDescription;
            this.dataObj.data.components[2].components[0][0].productCard.cardText[1].cardValue =
            response.productDetails[0].creditInterestRateFixed;
            this.dataObj.data.components[2].components[0][0].productCard.cardText[2].cardValue =
            response.productDetails[0].currencyCode;
            this.dataObj.data.components[2].components[0][0].productCard.cardText[3].cardValue =
            response.productDetails[0].debitInterestRateFixed;
            this.dataObj.data.components[3].components[0][0].productCard.cardTitle1Value =
            response.productDetails[1].productDescription;
            this.dataObj.data.components[2].components[0][0].productCard.cardText[0].cardValue =
            response.productDetails[0].minimumAccountOpeningBalance?.value || 0;
            this.dataObj.data.components[3].components[0][0].productCard.cardText[0].cardValue =
            response.productDetails[1].minimumAccountOpeningBalance?.value || 0;
            this.dataObj.data.components[3].components[0][0].productCard.cardText[1].cardValue =
            response.productDetails[1].creditInterestRateFixed;
            this.dataObj.data.components[3].components[0][0].productCard.cardText[2].cardValue =
            response.productDetails[1].currencyCode;
            this.dataObj.data.components[3].components[0][0].productCard.cardText[3].cardValue =
            response.productDetails[1].debitInterestRateFixed;
            this.dataObj.data.components[1].components[1][0].disabled = true;
          }
          this.mobileNumber = countryCode + ' ' + phoneNumber;
        } else if (action?.name === 'continueCompare') {
          localStorage.setItem('formInputData', JSON.stringify(this.formInput.data));
          const status = await CommonService.sendOTP(urlObj.sendOTP, {
            mobileCountryCode: this.productCompareCode,
            mobilePhoneNumber: this.productCompareNumber,
          });

          if (status && [400, 401, 403, 404, 413, 429, 500, 503].includes(status?.status)) {
            this.displaySnackBar({ title: status?.data?.title, content: status?.data?.causes[0].message, type: 'error' });
          } else {
            const b2bSessionId = status?.b2bSessionId;

            store.dispatch('userStore/setUserData', {
              b2bSessionId,
            });
            localStorage.setItem('referenceCode', status.referenceCode);
            if (this.formInput.data.card === 'true') {
              this.$router.push({ params: { action: 'otpVerificationProduct' } });
            } else if (this.formInput.data.card2 === 'true') {
              const productCode = this.productCompareResponse.productDetails[1].productCode;
              if (this.productCompareResponse.productDetails[1].productSubType !== null && this.productCompareResponse.productDetails[1].productSubType !== undefined && this.productCompareResponse.productDetails[1].productSubType !== '') {
                this.resumeProductType = this.productCompareResponse.productDetails[1].productSubType;
                this.resumeProductTerm = this.getProductTerm;
              } else {
                this.productItems?.forEach((item) => {
                  if (item.code === productCode) {
                    this.resumeProductType = item.type;
                  }
                });
                this.productItems?.forEach((item) => {
                  if (item.code === productCode) {
                    this.resumeProductTerm = item.term;
                  }
                });
              }
              const applicationCode = 'fede';
              const otppage = 'otpVerificationProduct';
              const timeOutUrl = window.location.protocol + '//' + window.location.hostname + ':' + window.location.port + '/' + applicationCode + '/' + this.resumeProductType + '/' + productCode + '/' + this.resumeProductTerm + '/' + otppage;
              window.location = timeOutUrl;
            }
          }
        } else if (action?.name === 'resend') {
          const status = await CommonService.sendOTP(urlObj.sendOTP, {
            mobileCountryCode: this.productCompareCode,
            mobilePhoneNumber: this.productCompareNumber,
          });

          if (status && [400, 401, 403, 404, 413, 429, 500, 503].includes(status?.status)) {
            this.displaySnackBar({ title: status?.data?.title, content: status?.data?.causes[0].message, type: 'error' });
          } else {
            localStorage.setItem('referenceCode', status.referenceCode);
            this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.codeSent'), type: 'success' });
          }
        } else if (action?.name === 'continueOTP') {
          const status = await CommonService.verifyOTP(urlObj.verifyOTP, {
            mobileCountryCode: this.productCompareCode,
            mobilePhoneNumber: this.productCompareNumber,
            otp: this.formInput.data.otp,
            referenceCode: this.formInput.data.referenceCode,
          });

          if (status && [400, 401, 403, 404, 413, 429, 500, 503].includes(status?.status)) {
            this.displaySnackBar({ title: status?.data?.title, content: status?.data?.causes[0].message, type: 'error' });
          } else {
            localStorage.setItem('referenceCode', status.referenceCode);
            this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.apiSuccess'), type: 'success' });
          }
        } else if (action?.name === 'hideGrid') {
          const countryCode = this.formInput.data.page1.mobileCountryCode;
          const phoneNumber = this.formInput.data.page1.mobilePhoneNumber;
          const status = await CommonService.sendOTP(urlObj.sendOTP, {
            mobileCountryCode: countryCode,
            mobilePhoneNumber: phoneNumber,
            b2bSessionId: this.formInput.data.page1.b2bSessionId,
          }, false);

          if (status && (status?.status === 400 || status?.status === 500)) {
            store.dispatch('appStore/setAppData', {
              inProgress: false,
            });
            this.displaySnackBar({ title: status?.data?.detail, content: status?.data?.causes[0]?.message, type: 'error' });
          } else {
            this.formInput.data.page1.referenceCode = status.referenceCode;
            this.dataObj && this.dataObj.data && this.dataObj.data.wizardSteps && this.dataObj.data.wizardSteps[0] && this.dataObj.data.wizardSteps[0].components && this.dataObj.data.wizardSteps[0].components.forEach((component) => {
              if (component.key === 'grid') {
                component.hidden = true;
              } else if (component.key === 'grid2') {
                component.hidden = true;
              } else if (component.key === 'grid3') {
                component.hidden = false;
              } else if (component.key === 'resendOtpGrid') {
                component.hidden = false;
              } else if (component.key === 'editMobileNumberGrid') {
                component.hidden = false;
              }
            });
          }
        } else if (action?.name === 'continueButton') {
          this.$router.push({ params: { action: 'productOnboard' } });
        } else if (action?.name === 'findSortCode') {
          const wizardStep = pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[0];

          this.dataObj && this.dataObj.data && this.dataObj.data.wizardSteps && this.dataObj.data.wizardSteps[wizardStep] && this.dataObj.data.wizardSteps[wizardStep].components && this.dataObj.data.wizardSteps[wizardStep].components.forEach((component) => {
            if (component.key === 'sortCheck') {
              for (let index = 0; index < component.components.length; index++) {
                component.components[index].forEach((subComponent) => {
                  if (subComponent.key === 'findSortCode') {
                    subComponent.disabled = true;
                  }
                });
              }
            } else if (component.key === 'searchGrid') {
              component.hidden = false;
              for (let index = 0; index < component.components.length; index++) {
                component.components[index].forEach((subComponent) => {
                  if (subComponent.key === 'confirmSortCode') {
                    subComponent.hidden = true;
                  } else if (subComponent.key === 'searchSortCode') {
                    subComponent.hidden = false;
                  } else if (subComponent.key === 'sortCode') {
                    subComponent.disabled = false;
                  } else if (subComponent.key === 'bankName1') {
                    subComponent.disabled = false;
                  } else if (subComponent.key === 'branchName') {
                    subComponent.disabled = false;
                  }
                });
              }
            }
          });
        } else if (action?.name === 'confirmSortCode') {
          const wizardStep = pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[0];

          this.dataObj && this.dataObj.data && this.dataObj.data.wizardSteps && this.dataObj.data.wizardSteps[wizardStep] && this.dataObj.data.wizardSteps[wizardStep].components && this.dataObj.data.wizardSteps[wizardStep].components.forEach((component) => {
            if (component.key === 'sortCheck') {
              for (let index = 0; index < component.components.length; index++) {
                component.components[index].forEach((subComponent) => {
                  if (subComponent.key === 'findSortCode') {
                    subComponent.hidden = true;
                  } else if (subComponent.key === 'changeSortCode') {
                    subComponent.hidden = false;
                    subComponent.disabled = false;
                  }
                });
              }
            } else if (component.key === 'searchGrid') {
              component.hidden = true;
            }
          });
          this.formInput.data[this.additionalInformationPage] = Object.assign(
            {},
            {
              ...this.formInput.data[this.additionalInformationPage],
              ...{
                sortCodeResult: this.formInput.data[this.additionalInformationPage].sortCode,
                bankName: this.formInput.data[this.additionalInformationPage].bankName1,
              },
            },
          );
          this.$forceUpdate();
        } else if (action?.name === 'changeSortCode') {
          const wizardStep = pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[0];

          this.dataObj && this.dataObj.data && this.dataObj.data.wizardSteps && this.dataObj.data.wizardSteps[wizardStep] && this.dataObj.data.wizardSteps[wizardStep].components && this.dataObj.data.wizardSteps[wizardStep].components.forEach((component) => {
            if (component.key === 'sortCheck') {
              for (let index = 0; index < component.components.length; index++) {
                component.components[index].forEach((subComponent) => {
                  if (subComponent.key === 'confirmSortCode') {
                    subComponent.disabled = true;
                  }
                });
              }
            } else if (component.key === 'searchGrid') {
              component.hidden = false;
              for (let index = 0; index < component.components.length; index++) {
                component.components[index].forEach((subComponent) => {
                  if (subComponent.key === 'confirmSortCode') {
                    subComponent.hidden = true;
                  } else if (subComponent.key === 'searchSortCode') {
                    subComponent.hidden = false;
                  } else if (subComponent.key === 'sortCode') {
                    subComponent.disabled = false;
                  } else if (subComponent.key === 'bankName1') {
                    subComponent.disabled = false;
                  } else if (subComponent.key === 'branchName') {
                    subComponent.disabled = false;
                  }
                });
              }
            }
          });
          this.formInput.data[this.additionalInformationPage] = Object.assign(
            {},
            {
              ...this.formInput.data[this.additionalInformationPage],
              ...{ sortCode: '', bankName1: '', branchName: '' },
            },
          );
          this.$forceUpdate();
        } else if (action?.name === 'cancelSortCode') {
          const wizardStep = pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[0];

          this.dataObj && this.dataObj.data && this.dataObj.data.wizardSteps && this.dataObj.data.wizardSteps[wizardStep] && this.dataObj.data.wizardSteps[wizardStep].components && this.dataObj.data.wizardSteps[wizardStep].components.forEach((component) => {
            if (component.key === 'sortCheck') {
              for (let index = 0; index < component.components.length; index++) {
                component.components[index].forEach((subComponent) => {
                  if (subComponent.key === 'findSortCode') {
                    subComponent.disabled = false;
                    subComponent.hidden = false;
                  } else if (subComponent.key === 'confirmSortCode') {
                    subComponent.hidden = true;
                  }
                });
              }
            } else if (component.key === 'searchGrid') {
              component.hidden = true;
            }
          });
        } else if (action?.name === 'cancel') {
          this.$router.push({ params: { action: 'customerOnboarding' } });
        } else if (action?.name === 'cancelCompare') {
          this.$router.go(0);
        } else if (action?.name === 'cancelOtp' || action?.name === 'otpCancel') {
          this.$router.push({ params: { action: 'resume' } });
        } else if (action?.name === 'editMobileNumber') {
          this.dataObj && this.dataObj.data && this.dataObj.data.wizardSteps && this.dataObj.data.wizardSteps[0] && this.dataObj.data.wizardSteps[0].components && this.dataObj.data.wizardSteps[0].components.forEach((component) => {
            if (component.key === 'grid') {
              component.hidden = false;
            } else if (component.key === 'grid2') {
              component.hidden = false;
            } else if (component.key === 'grid3') {
              component.hidden = true;
            } else if (component.key === 'resendOtpGrid') {
              component.hidden = true;
            } else if (component.key === 'editMobileNumberGrid') {
              component.hidden = true;
            }
          });
          this.dataObj.data.wizardSteps[0].nextButtonHasDependentComponents = true;
          if (this.dataObj.data.wizardSteps[0].nextButtonDependentComponents[0]?.verified) {
            this.dataObj.data.wizardSteps[0].nextButtonDependentComponents[0].verified = false;
          }
        }
      }
    },
    async onSubmit(e) {
      const { payload } = e;

      let { messageProperties } = payload;
      let saveResponse;
      let apiPayload = {};
      const webhookAction = payload.formActions[0];
      const messageStatusCodeList = [];

      if (messageProperties) {
        messageProperties.forEach((property) => {
          messageStatusCodeList.push(property.messageStatusCode);
        });
      }

      // this for assigning default form values when reset is done
      if (this.tempFormInput && this.keysEqual(payload.formData, this.tempFormInput)) {
        const tempPayload = this.tempFormInput;

        Object.keys(payload.formData).forEach(function(key) {
          if (
            !payload.formData[key] &&
            (tempPayload[key] === 'false' || tempPayload[key] === 'true')
          ) {
            payload.formData[key] = tempPayload[key];
          }
        });
        this.tempFormInput = this.getInitialData().tempFormInput;
      }

      // we will add query params to the url in the below code
      let { staticParams, dynamicParams, requestURL: url } = webhookAction;
      const pageSize = store.getters['userStore/userData']?.fecaProps?.['page.size'] || 0;

      // Update path params value in the URL
      const regx = /{{[a-zA-Z]*}}/g;
      const datasourceUrlParams = url.match(regx);
      datasourceUrlParams?.shift(); // remove first field because, it is baseURL (feus,fesd,etc)

      if (datasourceUrlParams && datasourceUrlParams.length) {
        datasourceUrlParams.forEach((param) => {
          const paramString = param.substring(2, param.length - 2);
          const paramRegx = new RegExp(`{{${paramString}}}`);

          url = url.replace(paramRegx, payload.formData[paramString]);
        });
      }

      if (webhookAction?.filterType) {
        if (webhookAction.filterType === 'static') {
          staticParams.forEach((params, index) => {
            // page and size are being assigned here for datatable pagination
            if (params.key === 'size') {
              params.value = pageSize;
            }
            if (params.key === 'page') {
              params.value = 0;
            }
            if (index === 0) {
              url += `?${params.key}=${params.value}`;
            } else {
              url += `&${params.key}=${params.value}`;
            }
          });
        } let restOfParams;
        dynamicParams.forEach((params, index) => {
          if (params.key === 'size') {
            params.value = pageSize;
          }
          if (params.key === 'page') {
            params.value = 0;
          }
          if (index === 0) {
            url += `?${params.key}=${payload.formData[params.value]}`;
          } else {
            restOfParams =
                params.key === 'size' || params.key === 'page'
                  ? params.value
                  : payload.formData[params.value] || '';
            url += `&${params.key}=${restOfParams}`;
          }
        });
      }
      if (webhookAction.requestMethod === 'GET') {
        saveResponse = await CommonService.getWebHookSearchResults(
          url,
          {},
          0,
          10,
          messageStatusCodeList,
        );
        if (saveResponse !== null && saveResponse !== '') {
          this.savePersonalResponse = saveResponse;
          this.saveResponse = saveResponse;
          this.response.entityId = saveResponse?.data?.entityId;

          const personalInformationData = saveResponse.data;

          store.dispatch('userStore/setUserData', {
            personalInformationData,
          });
          const saveResponseData = JSON.parse(saveResponse?.data?.accountInformation);

          this.saveResponseData = saveResponseData;
          const personalInformation = JSON.parse(saveResponse?.data?.personalInformation);
          const productInformation = JSON.parse(saveResponse?.data?.productInformation);
          const localeSelected = localStorage.getItem('localeSelected');

          this.differentLanguage = this.locales?.length > 1 && saveResponse.data.personalInformation !== null && personalInformation?.preferredLanguageCode !== '' && personalInformation?.preferredLanguageCode !== undefined ? (personalInformation.preferredLanguageCode !== localeSelected) : false;
          if (this.differentLanguage === false) {
            if (this.getProductType === 'lifetimeISA' && productInformation?.productId !== this.getProductCode) {
              localStorage.setItem('productSwitch', true);
              this.$router.push({ params: { action: 'eligibilityCheck' } });
            } else {
              this.languageDifferent(this.saveResponseData);
            }
          }
        }
      } else {
        webhookAction.requestPayload.forEach((data) => {
          apiPayload[data.value] = payload.formData[data.value];
        });

        // Below method is added to construct UDF payload in PROD mode
        apiPayload = await this.getConstructedOnSubmitUDFPayload({
          mode: process.env.NODE_ENV,
          webhookAction,
          apiPayload,
          payload,
        });
        if (webhookAction.requestMethod === 'POST') {
          saveResponse = await CommonService.addWebHookData(url, apiPayload, messageStatusCodeList);
          const b2bSessionId = saveResponse?.data?.b2bSessionId;

          if (b2bSessionId) {
            store.dispatch('userStore/setUserData', {
              b2bSessionId: b2bSessionId,
            });
          }
          if (saveResponse && saveResponse.data && saveResponse.data.isEligibilityCheckPassed === true) {
            if (this.formInput && this.formInput.data && this.formInput.data?.legalAgeFlag === 'true') {
              localStorage.setItem('isLisaTransferInWithAgeCheck', true);
            } else if (this.formInput && this.formInput.data && this.formInput.data?.legalAgeFlag === 'false' && this.formInput.data.isLisaTransferIn === 'true') {
              localStorage.setItem('isLisaTransferInWithAgeCheck', false);
            }
            if (this.getProductType !== 'lifetimeISA') {
              if (this.currentActionRoute === 'secondaryEligibilityCheck') {
                this.$router.push({ params: { action: 'secondaryApplicantOnboard' } });
              } else {
                this.$router.push({ params: { action: 'productOnboard' } });
              }
            } else if (this.getProductType === 'lifetimeISA' && (localStorage.getItem('productSwitch') === null || localStorage.getItem('productSwitch') === 'false')) {
              this.$router.push({ params: { action: 'productOnboard' } });
            } else {
              this.languageDifferent(this.saveResponseData);
            }
          } else if (saveResponse && saveResponse.data && saveResponse.data.isEligibilityCheckPassed === false) {
            this.dataObj && this.dataObj.data && this.dataObj.data.components && this.dataObj.data.components.forEach((component) => {
              if (component.key === 'buttonGrid') {
                for (let index = 0; index < component.components.length; index++) {
                  component.components[index].forEach((subComponent) => {
                    if (subComponent.key === 'confirmButton') {
                      subComponent.disabled = true;
                    }
                  });
                }
              }
            });
            messageProperties = [
              {
                messageDisplayType: 'popUp',
                messageStatusCode: 201,
                popUpImage: false,
                messageType: 'error',
                messageColor: '',
                messageIcon: '',
                messageInfoType: 'static',
                messageTitle: saveResponse.data.title,
                messageContent: saveResponse.data.message,
                messageTitleKey: '',
                messageContentKey: '',
              },
            ];
          } else if (saveResponse && saveResponse.data && saveResponse?.status === 200 && saveResponse.data.referenceCode !== undefined && saveResponse.data.referenceCode !== '') {
            localStorage.setItem('referenceCode', saveResponse.data.referenceCode);
            const countryCode = this.formInput?.data?.mobileCountryCode;
            const phoneNumber = this.formInput?.data?.mobilePhoneNumber;
            const mobile = {
              mobilePhoneNumber: phoneNumber,
              mobileCountryCode: countryCode,
            };
            const b2bSessionId = saveResponse?.data?.b2bSessionId;

            store.dispatch('userStore/setUserData', {
              b2bSessionId,
            });

            localStorage.setItem('mobileNumber', JSON.stringify(mobile));
            this.$router.push({ params: { action: 'otpVerification' } });
          } else if (saveResponse && saveResponse.data && saveResponse.data.isDifferentFromExistingProduct === false) {
            const b2bSessionId = saveResponse?.data?.b2bSessionId;

            saveResponse = await CommonService.quitApplication(`${urlObj.quitApplication}/${this.formInput.data.mobileFormattedCode}/${this.formInput.data.mobilePhoneNumber}`, { b2bSessionId: b2bSessionId });
            if (saveResponse && saveResponse.data && saveResponse.data.causes && saveResponse.data?.causes[0]?.message.includes('There is no pending application found.')) {
              this.dataNotFound = true;
            }
            if (saveResponse !== null && saveResponse !== undefined && !saveResponse.data.causes) {
              this.savePersonalResponse = saveResponse;
              this.saveResponse = saveResponse;
              this.response.entityId = saveResponse.data ? saveResponse.data.entityId : saveResponse;
              const personalInformationData = saveResponse.data;
              const personalInformation = JSON.parse(saveResponse?.data?.personalInformation);
              const productInformation = JSON.parse(saveResponse?.data?.productInformation);
              const localeSelected = localStorage.getItem('localeSelected');

              store.dispatch('userStore/setUserData', {
                personalInformationData,
              });

              this.differentLanguage = saveResponse.data.personalInformation !== null ? personalInformation && personalInformation.preferredLanguageCode ? (personalInformation.preferredLanguageCode !== localeSelected) : false : false;
              if (this.differentLanguage === false) {
                if (this.getProductType === 'lifetimeISA' && productInformation?.productId !== this.getProductCode) {
                  localStorage.setItem('productSwitch', true);
                  this.$router.push({ params: { action: 'eligibilityCheck' } });
                } else {
                  this.languageDifferent();
                }
              }
            }
          } else if (saveResponse && saveResponse.data && saveResponse.data.isDifferentFromExistingProduct === true) {
            if (this.formInput?.data?.mobileCountryCode !== '+44') {
              const countryData = window.intlTelInputGlobals.getCountryData();
              const countryCode = (countryData.find((data) => data.dialCode === this.formInput?.data?.mobileCountryCode.replace('+', '')))?.iso2;

              store.dispatch('userStore/setUserData', {
                countryCode,
              });
            }
            const b2bSessionId = saveResponse?.data?.b2bSessionId;

            store.dispatch('userStore/setUserData', {
              b2bSessionId,
            });
            this.productCompareResponse = saveResponse;
            localStorage.setItem('productValidationResponse', JSON.stringify(saveResponse.data));
            this.$router.push({ params: { action: 'otpVerificationProduct' } });
          } else if (saveResponse && saveResponse.data && saveResponse.data.causes && saveResponse.data?.causes[0]?.message.includes('There is no data available for the entered Mobile Number. ')) {
            this.mobileNumber = this.formInput.data.mobileCountryCode + ' ' + this.formInput.data.mobilePhoneNumber;
            this.dataNotFound = true;
          } else if (saveResponse && saveResponse.data && saveResponse.data.causes && (this.$appSettings?.errorCodes?.includes(saveResponse.data?.causes[0]?.code) || saveResponse.data?.causes[0]?.message.includes('Invalid product information. Failed to fetch product details') || saveResponse.data?.causes[0]?.message.includes('Your previously chosen product is no longer available or invalid.'))
          ) {
            this.invalidProductCode = true;
            this.previousExpired = true;
          } else if (saveResponse && saveResponse.data && saveResponse.data.causes && saveResponse.data.causes[0].message.includes('You are already a client')) {
            messageProperties = [
              {
                messageDisplayType: 'popUp',
                messageStatusCode: 400,
                popUpImage: false,
                messageType: 'error',
                messageColor: '',
                messageIcon: '',
                messageInfoType: 'static',
                messageTitle: this.$t('messages.save.partyPresentTitle'),
                messageContent: this.$t('messages.save.partyPresentContent'),
                messageTitleKey: '',
                messageContentKey: '',
              },
            ];
          } else if (url.includes('retrieve-application') && saveResponse !== null && saveResponse !== '') {
            this.savePersonalResponse = saveResponse;
            this.saveResponse = saveResponse;
            this.response.entityId = saveResponse?.data?.entityId;

            const personalInformationData = saveResponse.data;

            store.dispatch('userStore/setUserData', {
              personalInformationData,
            });
            const saveResponseData = saveResponse?.data;

            this.saveResponseData = saveResponseData;

            const personalInformation = JSON.parse(saveResponse?.data?.personalInformation);
            const productInformation = JSON.parse(saveResponse?.data?.productInformation);
            const localeSelected = localStorage.getItem('localeSelected');

            this.differentLanguage = this.locales?.length > 1 && saveResponse.data.personalInformation !== null && personalInformation?.preferredLanguageCode !== '' ? (personalInformation.preferredLanguageCode !== localeSelected) : false;
            if (this.differentLanguage === false) {
              if (this.getProductType === 'lifetimeISA' && productInformation?.productId !== this.getProductCode) {
                localStorage.setItem('productSwitch', true);
                this.$router.push({ params: { action: 'eligibilityCheck' } });
              } else {
                this.languageDifferent(this.saveResponseData);
              }
            }
          }
        }
        if (webhookAction.requestMethod === 'PUT') {
          saveResponse = await CommonService.updateWebHookData(
            url,
            apiPayload,
            messageStatusCodeList,
          );
        }
        if (webhookAction.requestMethod === 'DELETE') {
          saveResponse = await CommonService.deleteWebHookData(url, apiPayload);
        }
      }

      if (messageProperties) {
        this.handleUserMessage(messageProperties, saveResponse);
        store.dispatch('appStore/setAppData', {
          inProgress: false,
        });
      }

      if (messageProperties) {
        this.handleUserMessage(messageProperties, saveResponse);
        store.dispatch('appStore/setAppData', {
          inProgress: false,
        });
      }

      if (saveResponse) {
        const { type } = webhookAction?.previewAsIn;

        switch (type) {
          case 'popUp':
            this.displayPopUpContent(saveResponse, webhookAction, payload.formData);
            break;
          case 'componentFields':
            this.displayComponentFields(saveResponse, webhookAction, payload.formData);
            break;
          default:
            this.submitAction(saveResponse, webhookAction?.submitAction, payload.formData);
        }
      }
    },
    async handleFormUpdate() {
      if (this.currentActionRoute !== 'customerOnboarding' && this.currentActionRoute !== 'productInfo' && this.currentActionRoute !== 'ReviewInformation' &&
      this.currentActionRoute !== 'onboardStatus'
      ) {
        let formData = {};
        const navMapFilename = this.checkRoutePath() ? this.navigationMapping[this.currentRoute][this.currentRoute] : this.currentActionRoute
          ? this.navigationMapping[this.getProductType][this.currentActionRoute] : this.navigationMapping[this.getProductType][this.currentActionRoute];
        let data = await this.fetchSchema({
          mode: process.env.NODE_ENV,
          tenantID: await CommonService.getTenantId() || process.env.DEFAULT_TENANTID,
          navMapFilename,
        });

        /* This API call is used fetch the ENV properties and it will be injected into Renderer */
        this.envProperties = await CommonService.getEnvProperties();
        this.currentEnvMode = process.env.NODE_ENV;
        this.udfEnabledForm = data?.data?.udfEnabled;
        if (!data?.data?.applicationCode) {
          data = await CommonService.getFormSchemaFromLocal(navMapFilename);
        }
        const formApplicationCode = data?.data?.applicationCode;

        // Inject b2bSessionId into schema defaults for secondaryApplicantOnboard (BEFORE assigning to dataObj)
        if ((this.currentActionRoute === 'secondaryApplicantOnboard' || this.currentActionRoute === 'productOnboard') && this.$route.query.type === undefined) {
          const primaryApplicantDetails = localStorage.getItem('additionalInfoData') ? JSON.parse(localStorage.getItem('additionalInfoData')) : null;
          const b2bSessionId = store.getters['userStore/userData']?.b2bSessionId || primaryApplicantDetails?.b2bSessionId;

          if (b2bSessionId && data?.data?.wizardSteps) {
            // Inject b2bSessionId as default value into ALL wizard steps
            data.data.wizardSteps.forEach((step) => {
              if (step?.components) {
                step.components.forEach((component) => {
                  if (component?.components) {
                    component.components.forEach((subComponents) => {
                      if (Array.isArray(subComponents)) {
                        subComponents.forEach((field) => {
                          if (field?.key === 'b2bSessionId') {
                            field.defaultValue = b2bSessionId;
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        }
        if (store.getters['userStore/userData'].isRefreshToken) {
          this.dataObj = data;
        } else {
          if (formApplicationCode.toLowerCase() === this.currentApplicationName.toLowerCase()) {
            this.dataObj = data;
          } else {
            this.modalConfig.enabled = true;
            this.modalConfig.content = `<h4>${this.$t('messages.formApplicationError')}</h4>`;
            this.modalConfig.title = `${this.$t('messages.formValidationTitle')}`;
            this.modalConfig.width = 610;
            this.modalConfig.hideToolbar = true;
            this.modalConfig.close = true;
            this.modalConfig.rounded = true;
            this.modalConfig.saveButton = `${this.$t('common.close')}`;
            this.modalConfig.saveCallback = () => {
              this.$router.push({ path: '/home' });
            };
            this.dataObj = undefined;
          }
        }
        if (Object.keys(this.formActionData).length) {
          let {
            datasourceUrl,
            item: selectedItem,
            values: mappingValues,
            messageMetaData: { messageProperties } = {},
          } = this.formActionData;

          if (this.formActionData.datasourceType === 'static') {
            const result = new Promise((resolve, reject) => {
              let data = {};

              if (this.formActionData.mapAllResponse) {
                data = selectedItem;
              } else if (mappingValues && mappingValues.length) {
                mappingValues.forEach((mappedData) => {
                  data[mappedData.targetFormData] = selectedItem[mappedData.sourceFormData];
                });
              }
              Object.keys(data).length ? resolve(data) : reject(new Error('Mapping failed in handleFormUpdate of Page.vue'));
            });
            formData = await result
              .then((data) => {
                return data;
              })
              .catch((error) => {
                console.log(error);
              });
          } else if (this.formActionData.datasourceType === 'url' && this.$route.params.action !== 'search') {
            const regx = /\{{([^}}]+)\}}/g;
            const urlParams = datasourceUrl.matchAll(regx);
            const messageStatusCodeList = [];

            if (urlParams) {
              for (const data of urlParams) {
                datasourceUrl = selectedItem[data[1]]
                  ? datasourceUrl.replace(data[0], selectedItem[data[1]])
                  : datasourceUrl;
              }
            }
            if (messageProperties?.length > 0) {
              messageProperties.forEach((property) => {
                messageStatusCodeList.push(property.messageStatusCode);
              });
            }

            const response = await CommonService.getPageData(
              datasourceUrl,
              {},
              messageStatusCodeList,
            );

            if (messageProperties?.length > 0) {
              this.handleUserMessage(messageProperties, response);
              store.dispatch('appStore/setAppData', {
                inProgress: false,
              });
            }

            if (this.formActionData.mapAllResponse) {
              formData = response;
            } else if (mappingValues && mappingValues.length) {
              mappingValues.forEach((mappedData) => {
                const responseMapping = 'response.' + mappedData.responseKey; //  eg: response.address.state
                /* eslint-disable no-eval */
                formData[mappedData.key] = eval(responseMapping);
              });
            }
          }
        }
        this.formActionData = {};

        this.formInput = Object.assign(
          {},
          {
            ...this.formInput,
            data: formData,
          },
        );

        this.formActionData = {};
      }
    },
    setActionRoute(dataType) {
      if (dataType === 'object') {
        const obj = this.navigationMapping[this.currentRoute][this.currentSubRoute];

        this.$route.params.action = this.currentActionRoute || Object.keys(obj)[0];
      }
    },
    checkRoutePath() {
      if (appSettings.routeOptions.includes(this.$route.query.type) && !this.currentSubRoute) {
        return true;
      } else {
        return false;
      }
    },
    keysEqual(obj1, obj2) {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      return keys1.length === keys2.length && keys1.every((key) => keys2.includes(key));
    },
    productInfoo() {
      localStorage.removeItem('productSwitch');
      this.$router.push({ params: { action: 'eligibilityCheck' } });
    },
    bankProduct() {
      const bankProductPage = appSettings.dco.bankProductPage;
      window.open(bankProductPage);
    },
    productIntro() {
      this.$router.push({ params: { action: 'productInfo' } });
    },
    async doAPiCall() {
      const getProductTypeLower = this.getProductType ? this.getProductType.toLowerCase() : '';
      const productTypesLower = Array.isArray(this.productTypes) ? this.productTypes.map((type) => type.toLowerCase()) : [];

      if (this.getProductType && this.getProductType !== null && this.getProductType !== '' && this.$appSettings?.dcoConfigurations?.productTypes && !this.$appSettings?.dcoConfigurations?.productTypes.includes(this.getProductType)) {
        this.popUp(this.$t('messages.save.invalidSubProduct'), this.$t('messages.save.invalidSubProductHelper'));
        return;
      }

      this.apiProductType = getProductTypeLower === 'termdeposit' ? 'termdeposit' : productTypesLower.includes(getProductTypeLower) ? 'currentsavings' : '';
      if (this.getProductType && this.getProductCode && this.getProductTerm) {
        const url = `${urlObj.product.productSummary}/${this.apiProductType.toLowerCase()}/${this.getProductCode}/${this.getProductTerm}`;
        const productInfo = await CommonService.getProductInfo(url);

        this.productData = productInfo;
        if (productInfo.status === 400) {
          this.popUp(this.$t('messages.save.invalidProduct'), this.$t('messages.save.invalidProductHelper'));
        } else if (productInfo.status === 500 || productInfo.status === 503) {
          this.popUp(this.$t('messages.save.systemDown'), this.$t('messages.save.essenceDown'));
        } else if (this.getProductType === 'termDeposit' && productInfo && productInfo?.data && productInfo?.data?.minimumBalance !== null && productInfo?.data?.minimumBalance?.value !== 0) {
          this.popUp(this.$t('messages.save.invalidProduct'), this.$t('messages.save.invalidProductHelper1'));
        } else if (this.getProductType === 'termDeposit' && productInfo && productInfo?.data && productInfo?.data?.isEndDateCommonForAllAccounts === true) {
          const currentDate = new Date().toISOString().split('T')[0];
          const productEndDate = productInfo?.data?.productEndDate ? new Date(productInfo?.data?.productEndDate).toISOString().split('T')[0] : null;
          let tenorValue = productEndDate !== null ? (new Date(productEndDate) - new Date(currentDate)) / (1000 * 60 * 60 * 24) : 0;

          if ((productInfo && productInfo.data && productInfo.data?.maximumTenorUnits === 'M') ||
          (productInfo && productInfo.data && productInfo.data?.maximumTenorUnits === 'Y')) { // this conversion of days to months or years is added to handle the negative scenario if the tenor units are in months or years from API response.
            const today = new Date();
            const endDate = new Date(today);
            endDate.setDate(today.getDate() + tenorValue);

            if (productInfo && productInfo.data && productInfo.data?.maximumTenorUnits === 'M') {
              let months = (endDate.getFullYear() - today.getFullYear()) * 12 + (endDate.getMonth() - today.getMonth());
              if (endDate.getDate() < today.getDate()) {
                months--;
              }
              tenorValue = months;
            } else if (productInfo && productInfo.data && productInfo.data?.maximumTenorUnits === 'Y') {
              let years = endDate.getFullYear() - today.getFullYear();
              if (endDate.getMonth() < today.getMonth() || (endDate.getMonth() === today.getMonth() && endDate.getDate() < today.getDate())) {
                years--;
              }
              tenorValue = years;
            }
          }
          if (productEndDate !== null && (productEndDate < currentDate || productEndDate === currentDate)) {
            this.popUp(this.$t('messages.save.invalidProduct'), this.$t('messages.save.invalidProductHelper'));
          } else if (tenorValue < productInfo?.data?.minimumTenorPeriod) {
            this.popUp(this.$t('messages.save.invalidProduct'), this.$t('messages.save.invalidProductHelper1'));
          } else if (tenorValue > productInfo?.data?.maximumTenorPeriod) {
            this.popUp(this.$t('messages.save.invalidProduct'), this.$t('messages.save.invalidProductHelper1'));
          }
        }
        if (store.getters['userStore/userData']) {
          store.dispatch('userStore/setUserData', {
            productInfo,
          });
        }
      }
      if (this.currentActionRoute === 'eligibilityCheck' || this.currentActionRoute === 'secondaryEligibilityCheck') {
        if (this.productData.data && this.productData.data.productDescription) {
          this.formInput.data = Object.assign(
            {},
            {
              ...this.formInput.data,
              ...{ productName: this.productData.data.productDescription },
            },
          );
        }
        if (this.currentActionRoute === 'secondaryEligibilityCheck') {
          this.formInput.data.anotherBankAccountAvailabilityFlag = 'true';
          this.formInput.data.secondary = true;
          if (this.getProductType === 'savings') {
            this.dataObj && this.dataObj.data && this.dataObj.data.components.forEach((component) => {
              component && component?.components && component?.components.forEach((subComponent) => {
            subComponent?.forEach((childComponent) => {
              if (childComponent && childComponent?.key === 'content') {
                childComponent.hidden = true;
              } else if (childComponent && childComponent?.key === 'secondaryApplicant') {
                childComponent.hidden = false;
              }
            });
              });
            });
          }
          this.formInput.data = Object.assign(
            {},
            {
              ...this.formInput.data,
              ...{ productName: this.productData.data.productDescription },
            },
          );
        }
      }
      if (this.currentActionRoute === 'productOnboard') {
        if (this.productData && this.productData.data && this.productData.data?.module.includes(this.$appSettings.module) && this.productData.data?.applicableAccountOperationType !== 'SOLE') {
          if (pageBasedOnProducts[this.getProductType][this.applicantType]?.accountInformation !== undefined) {
            this.dataObj.data.wizardSteps[1].enabled = true;
          }
        }
      }
    },
    productCompare() {
      this.$router.push({ params: { action: 'resume' } });
    },
    logIn() {
      const logIn = appSettings.dco.logIn;
      window.location.href = logIn;
    },
    async handleLocaleChanges(e) {
      const locale = this.locales[e].code;
      this.localeSet = locale;
      const localeMesg = await CommonService.getLocaleData(locale);

      localStorage.setItem('localeSelected', locale);
      this.$vuetify.rtl = !!this.isRTL.includes(locale);
      this.$i18n.locale = locale;
      this.$i18n.setLocaleMessage(locale, localeMesg[localeMesg.lang]);
    },
    languageSwitch(response) {
      this.differentLanguage = false;

      const responseReceived = response !== '' && response !== undefined ? this.handleLocaleChanges(response) : false;

      if (responseReceived !== false) {
        localStorage.setItem('localeSelected', this.localeSet);
      }
      const productInformation = JSON.parse(this.saveResponse.data.productInformation);

      if (this.getProductType === 'lifetimeISA' && productInformation?.productId !== this.getProductCode) {
        localStorage.setItem('productSwitch', true);
        this.$router.push({ params: { action: 'eligibilityCheck' } });
      } else {
        this.languageDifferent(this.saveResponseData);
      }
    },
    async updateAddressDetails(key, data) {
      const addressDetails = await CommonService.residentialAddress(`${urlObj.residentialAddress}/${data.addressId}`);

      if (key === 'previousResidentialAddress') {
        this.formInput.data[this.personalInformationPage] = Object.assign(
          {},
          {
            ...this.formInput.data[this.personalInformationPage],
            ...{
              addressId2: addressDetails.data.addressId,
              postCode21: addressDetails.data.postCode,
              addressLine21: addressDetails.data?.addressLine1,
              addressLine22: addressDetails.data?.addressLine2,
              addressLine23: addressDetails.data?.addressLine3,
              addressLine24: addressDetails.data?.addressLine4,
              city2: addressDetails.data?.city,
              countryCode2: addressDetails.data?.countryCode,
              previousStateOrprovince: addressDetails.data?.region,
            },
          },
        );
      } else if (key === 'correspondenceAddress') {
        this.formInput.data[this.personalInformationPage] = Object.assign(
          {},
          {
            ...this.formInput.data[this.personalInformationPage],
            ...{
              addressId1: addressDetails.data.addressId,
              postCode11: addressDetails.data.postCode,
              addressLine11: addressDetails.data?.addressLine1,
              addressLine12: addressDetails.data?.addressLine2,
              addressLine13: addressDetails.data?.addressLine3,
              addressLine14: addressDetails.data?.addressLine4,
              city1: addressDetails.data?.city,
              countryCode1: addressDetails.data?.countryCode,
              correspondenceStateOrprovince: addressDetails.data?.region,
            },
          },
        );
      } else if (key === 'residentialAddress') {
        this.formInput.data[this.personalInformationPage] = Object.assign(
          {},
          {
            ...this.formInput.data[this.personalInformationPage],
            ...{
              primaryAddressId: addressDetails.data.addressId,
              primaryPostCode: addressDetails.data.postCode,
              primaryAddressLine1: addressDetails.data?.addressLine1,
              primaryAddressLine2: addressDetails.data?.addressLine2,
              primaryAddressLine3: addressDetails.data?.addressLine3,
              primaryAddressLine4: addressDetails.data?.addressLine4,
              primaryCity: addressDetails.data?.city,
              primaryCountryCode: addressDetails.data?.countryCode,
              primaryStateOrprovince: addressDetails.data?.region,
            },
          },
        );
      }
    },
    popUp(title, content) {
      const messageProperties = [
        {
          messageDisplayType: 'popUp',
          messageStatusCode: 400,
          popUpImage: false,
          messageType: 'error',
          messageColor: '',
          messageIcon: '',
          messageInfoType: 'static',
          messageTitle: title,
          messageContent: content,
          messageTitleKey: '',
          messageContentKey: '',
        },
      ];
      const saveResponse = {
        data: {},
        status: 400,
      };

      this.handleUserMessage(messageProperties, saveResponse);
    },
  },
  watch: {
    async $route(to, from) {
      this.productType = this.$route.params.productType;
      if (this.currentActionRoute === 'productOnboard') {
        this.applicantType = 'primary';
      } else if (this.currentActionRoute === 'secondaryApplicantOnboard') {
        this.applicantType = 'secondary';
      } else if (this.currentActionRoute === 'secondaryEligibilityCheck') {
        this.applicantType = 'secondary';
      }
      if (['customerOnboarding', 'eligibilityCheck', 'secondaryEligibilityCheck', 'productOnboard', 'secondaryApplicantProductOnboard', 'ReviewInformation'].includes(this.currentActionRoute)) {
        this.doAPiCall();
      }
      if (this.$route.path !== '/') {
        this.dataType = typeof (this.checkRoutePath()
          ? this.navigationMapping[this.currentRoute][this.currentRoute]
          : this.navigationMapping[this.getProductType][this.currentActionRoute]);
        /* Below method is used when navigationMapping contains an action route
        and dependency has been removed for default search action route */
        this.setActionRoute(this.dataType);
        this.formCode =
          this.dataType === 'object' ? this.navigationMapping[this.currentRoute][this.currentSubRoute][
            this.actionType || this.currentActionRoute]
            : this.checkRoutePath()
              ? this.navigationMapping[this.currentRoute][this.currentRoute]
              : this.navigationMapping[this.getProductType][this.currentActionRoute];
        this.dataObj = this.getInitialData().dataObj;
        this.formInput = this.getInitialData().formInput;

        // Set b2bSessionId in formInput.data BEFORE handleFormUpdate for secondaryApplicantOnboard
        if (this.currentActionRoute === 'secondaryApplicantOnboard' && this.$route.query.type === undefined) {
          const primaryApplicantDetails = localStorage.getItem('additionalInfoData') ? JSON.parse(localStorage.getItem('additionalInfoData')) : store.getters['userStore/userData'].personalInformationData ? JSON.parse(store.getters['userStore/userData'].personalInformationData) : null;
          const b2bSessionId = store.getters['userStore/userData']?.b2bSessionId || primaryApplicantDetails?.b2bSessionId;

          if (b2bSessionId) {
            // Use dynamic page references
            const personalPage = pageBasedOnProducts?.[this.getProductType]?.secondary?.personalInformation[1] || 'page2';
            const additionalPage = pageBasedOnProducts?.[this.getProductType]?.secondary?.additionalInformation[1] || 'page3';

            // Initialize the data objects if they don't exist
            if (!this.formInput.data) {
              this.formInput.data = {};
            }
            if (!this.formInput.data.page1) {
              this.formInput.data.page1 = {};
            }
            if (!this.formInput.data[personalPage]) {
              this.formInput.data[personalPage] = {};
            }
            if (!this.formInput.data[additionalPage]) {
              this.formInput.data[additionalPage] = {};
            }

            // Set b2bSessionId in all pages
            this.formInput.data.page1.b2bSessionId = b2bSessionId;
            this.formInput.data[personalPage].b2bSessionId = b2bSessionId;
            this.formInput.data[additionalPage].b2bSessionId = b2bSessionId;
          }
        }

        this.isAlertVisibile = false;
        await this.handleFormUpdate();

        // IMMEDIATELY set b2bSessionId after handleFormUpdate for secondaryApplicantOnboard
        if (this.currentActionRoute === 'secondaryApplicantOnboard' && this.$route.query.type === undefined) {
          const primaryApplicantDetails = localStorage.getItem('additionalInfoData') ? JSON.parse(localStorage.getItem('additionalInfoData')) : store.getters['userStore/userData'].personalInformationData ? JSON.parse(store.getters['userStore/userData'].personalInformationData) : null;
          const b2bSessionId = store.getters['userStore/userData']?.b2bSessionId || primaryApplicantDetails?.b2bSessionId;

          if (b2bSessionId) {
            const personalPage = pageBasedOnProducts?.[this.getProductType]?.secondary?.personalInformation[1] || 'page2';
            const additionalPage = pageBasedOnProducts?.[this.getProductType]?.secondary?.additionalInformation[1] || 'page3';

            // Directly set b2bSessionId in existing objects (synchronous, no waiting)
            if (!this.formInput.data.page1) this.formInput.data.page1 = {};
            if (!this.formInput.data[personalPage]) this.formInput.data[personalPage] = {};
            if (!this.formInput.data[additionalPage]) this.formInput.data[additionalPage] = {};

            this.formInput.data.page1.b2bSessionId = b2bSessionId;
            this.formInput.data[personalPage].b2bSessionId = b2bSessionId;
            this.formInput.data[additionalPage].b2bSessionId = b2bSessionId;
          }
        }
      }
      if (this.currentActionRoute === 'eligibilityCheck' || this.currentActionRoute === 'secondaryEligibilityCheck') {
        this.formInput.data = Object.assign(
          {},
          {
            ...this.formInput.data,
            ...{ productName: this.productData.data.productDescription },
          },
        );
      }
      if (this.currentActionRoute === 'customerOnboarding') {
        // reset the locale informations
        localStorage.setItem('localeSelected', 'en_GB');
        this.$vuetify.ltr = true;
        this.$vuetify.rtl = !!this.isRTL.includes('en_GB');
        this.$i18n.locale = 'en_GB';
        this.language = 'en_GB';
        this.localeToggle = 0;
      }
      if (this.currentActionRoute === 'secondaryEligibilityCheck') {
        this.formInput.data.secondary = true;
        if (this.getProductType === 'savings') {
          this.dataObj && this.dataObj.data && this.dataObj.data.components.forEach((component) => {
            component && component?.components && component?.components.forEach((subComponent) => {
            subComponent?.forEach((childComponent) => {
              if (childComponent && childComponent?.key === 'content') {
                childComponent.hidden = true;
              } else if (childComponent && childComponent?.key === 'secondaryApplicant') {
                childComponent.hidden = false;
              }
            });
            });
          });
        }
        this.formInput.data = Object.assign(
          {},
          {
            ...this.formInput.data,
            ...{ productName: this.productData.data.productDescription },
          },
        );
      }
      if (this.currentActionRoute === 'secondaryApplicantOnboard' && this.$route.query.type === undefined) {
        const primaryApplicantDetails = localStorage.getItem('additionalInfoData') ? JSON.parse(localStorage.getItem('additionalInfoData')) : store.getters['userStore/userData'].personalInformationData ? JSON.parse(store.getters['userStore/userData'].personalInformationData) : null;
        const b2bSessionId = store.getters['userStore/userData']?.b2bSessionId;

        // Use dynamic page references for secondary applicants
        const personalPage = pageBasedOnProducts?.[this.getProductType]?.secondary?.personalInformation[1] || 'page2';
        const additionalPage = pageBasedOnProducts?.[this.getProductType]?.secondary?.additionalInformation[1] || 'page3';

        if (this.formInput.data.page1) {
          this.formInput.data.page1.primaryApplicantData = JSON.stringify(primaryApplicantDetails);
          this.formInput.data.page1 = Object.assign(
            {},
            {
              ...this.formInput.data.page1,
              ...{ primaryApplicantMobileCountryCode: primaryApplicantDetails.mobileCountryCode },
              ...{ primaryApplicantMobilePhoneNumber: primaryApplicantDetails.mobilePhoneNumber },
              ...{ primaryApplicantEmailId: primaryApplicantDetails.emailId },
              ...{ b2bSessionId: b2bSessionId },
            },
          );
        }
        if (this.formInput.data[personalPage]) {
          this.formInput.data[personalPage].b2bSessionId = b2bSessionId;
        }
        if (this.formInput.data[additionalPage]) {
          this.formInput.data[additionalPage].b2bSessionId = b2bSessionId;
        }
        this.$forceUpdate();
      }
      this.$route.query.type === 'AccountInformation' ? this.index = 0 : this.$route.query.type === 'PersonalInformation' ? (this.index = (pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]) - 1) : this.$route.query.type === 'AdditionalInformation'
        ? (this.index = (pageBasedOnProducts[this.getProductType][this.applicantType]?.additionalInformation[0]) - 1) : (this.index = -1);
      if (this.$route.query.type === 'AccountInformation') {
        this.formInput.data.page2.b2bSessionId = this.savePersonalResponse.data?.b2bSessionId;
        this.formInput.data.page2.initialSavedData = this.changedProduct ? localStorage.getItem('additionalInfoData') : JSON.stringify(this.savePersonalResponse.data);
        this.formInput.data[this.personalInformationPage].b2bSessionId = this.savePersonalResponse.data?.b2bSessionId;
        this.formInput.data[this.additionalInformationPage].b2bSessionId = this.savePersonalResponse.data?.b2bSessionId;
        if (['savings', 'termDeposit'].includes(this.getProductType) && ['joint', 'JOINT'].includes(this.productData.data.applicableAccountOperationType)) {
          this.formInput.data.page2.accountOwnership = 'JOINT';
          this.dataObj.data.wizardSteps[1].components.forEach((component) => {
            if (component.key === 'grid1') {
              component && component?.components.forEach((subComponent) => {
                if (subComponent.key === 'accountOwnership') {
                  subComponent.disabled = 'true';
                }
              });
            } else if (component?.key === 'accountOwner') {
              component.hidden = false;
              component && component?.components.forEach((subComponent) => {
                if (subComponent.key === 'accountOwnership') {
                  subComponent.disabled = 'true';
                }
              });
            }
          });
        }
      }
      if (this.$route.query.type === 'PersonalInformation' && (this.savePersonalResponse.data.personalInformation === null || (this.applicantType === 'secondary' && JSON.parse(this.savePersonalResponse.data.personalInformation).secondaryApplicantsPersonalInformation[0]?.secondaryApplicantsEmailId === undefined))) {
        const productMapping = store?.getters['userStore/userData']?.productInfo;
        const otherInformation = JSON.parse(this.savePersonalResponse.data.otherInformation);

        this.formInput.data[this.personalInformationPage].b2bSessionId = this.savePersonalResponse.data?.b2bSessionId;
        this.formInput.data[this.additionalInformationPage].b2bSessionId = this.savePersonalResponse.data?.b2bSessionId;
        this.formInput.data[this.personalInformationPage].resumeResponse = JSON.stringify(this.savePersonalResponse.data);
        this.formInput.data[this.personalInformationPage].productType = this.apiProductType.toLowerCase();
        this.formInput.data[this.personalInformationPage].productCode = productMapping.data.productCode;
        this.formInput.data[this.personalInformationPage].currencyCode = productMapping.data.currencyCode;
        this.formInput.data[this.personalInformationPage].displayProductType = this.getProductType.toLowerCase();
        this.formInput.data[this.personalInformationPage].productSubType = this.getProductType;
        this.formInput.data[this.personalInformationPage].module = productMapping.data.module;
        if (['cashISA', 'lifetimeISA', 'noticeDeposit', 'currentAccount'].includes(this.getProductType)) {
          this.formInput.data[this.personalInformationPage].accountOwnership = 'SOLE';
          this.formInput.data[this.personalInformationPage].modeOfOperation = 'SOLE';
        }
        const localeSelected = localStorage.getItem('localeSelected');

        this.formInput.data[this.personalInformationPage].preferredLanguageCode = localeSelected;
        this.formInput.data[this.personalInformationPage].isFromResumeProcess = 'true';
        this.formInput.data[this.personalInformationPage].entityId1 = this.savePersonalResponse.data.entityId;
        this.formInput.data[this.additionalInformationPage].entityId1 = this.savePersonalResponse.data.entityId;
        this.formInput.data[this.personalInformationPage].partiallySavedData = JSON.stringify(this.savePersonalResponse?.data);
        this.formInput.data[this.personalInformationPage].entityId = this.savePersonalResponse.data.entityId;
        this.formInput.data.entityId = this.response.entityId;

        const statusInformation = JSON.parse(this.savePersonalResponse.data.statusInformation);

        this.formInput.data[this.personalInformationPage].identityVerificationEnabled1 = statusInformation?.identityVerificationEnabled;
        this.formInput.data[this.personalInformationPage].otherInformation = this.savePersonalResponse.data?.otherInformation;
        this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled = otherInformation?.addressLookupEnabled === true ? 'true' : 'false';
        this.formInput.data[this.personalInformationPage].statusInformation = JSON.stringify(statusInformation);

        const transferInValidation = otherInformation && otherInformation?.lisaTransferInWithAgeValidation !== undefined && otherInformation?.lisaTransferInWithAgeValidation !== null ? otherInformation?.lisaTransferInWithAgeValidation : localStorage.getItem('isLisaTransferInWithAgeCheck');
        const isLisaTransferInWithAgeCheck = transferInValidation;

        localStorage.setItem('isLisaTransferInWithAgeCheck', isLisaTransferInWithAgeCheck);
        this.IDVForSecondaryApplicant = !(localStorage.getItem('IDVForSecondaryApplicant') === 'false' || localStorage.getItem('IDVForSecondaryApplicant') === false);
        if (statusInformation?.identityVerificationEnabled === false || !this.IDVForSecondaryApplicant) {
          const idvWizard = this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components;

          idvWizard.forEach((grid) => {
            if (grid.key === 'identityGrid' || grid.key === 'taxGrid') {
              if (grid?.components && grid.components.length > 0) {
                for (let index = 0; index < grid.components.length; index++) {
                  for (let subComponent = 0; subComponent < grid.components[index].length; subComponent++) {
                    if (grid.components[index][subComponent].type === 'file') {
                      grid.components[index][subComponent].hidden = false;
                    } else if (grid.components[index][subComponent].type === 'HTMLcontent' && grid.key !== 'taxGrid') {
                      grid.components[index][subComponent].hidden = false;
                    }
                  }
                }
              }
            }
          });
        } else {
          const idvWizard = this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components;

          idvWizard.forEach((grid) => {
            if (grid.key === 'taxGrid') {
              if (grid?.components && grid.components.length > 0) {
                for (let index = 0; index < grid.components.length; index++) {
                  for (let subComponent = 0; subComponent < grid.components[index].length; subComponent++) {
                    if (grid.components[index][subComponent].type === 'file') {
                      grid.components[index][subComponent].hidden = true;
                    }
                  }
                }
              }
            }
          });
        }
        if (this.applicantType === 'secondary') {
          this.formInput.data[this.personalInformationPage].addressSameAsPrimary = 'true';
        }
        if (this.applicantType !== 'secondary') {
          if (this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled === 'true') {
            this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components.forEach((component) => {
              if (component?.key === 'addressGrid' || component?.key === 'addressDateGrid') {
                component.hidden = false;
                component && component.components.forEach((subComponent) => {
                  subComponent && subComponent.forEach((childComponent) => {
                    if (childComponent?.key === 'residentialAddress') {
                      childComponent.hidden = false;
                    }
                    if (childComponent?.key === 'previousResidentialAddress' || childComponent?.key === 'fromDate' || childComponent?.key === 'toDate') {
                      childComponent.hidden = true;
                    }
                  });
                });
              }
            });
          } else if (this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled === 'false') {
            this.formInput.data[this.personalInformationPage].manualAddressToggle = 'true';
            this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components.forEach((component) => {
              if (component?.key === 'addressGrid' || component?.key === 'addressDateGrid') {
                component.hidden = true;
                component && component.components.forEach((subComponent) => {
                  subComponent && subComponent.forEach((childComponent) => {
                    if (childComponent?.key === 'residentialAddress') {
                      childComponent.hidden = true;
                    }
                  });
                });
              } else if (component?.key === 'manualAddressGrid') {
                component.hidden = false;
                component && component.components.forEach((subComponent) => {
                  subComponent && subComponent.forEach((childComponent) => {
                    if (childComponent?.key === 'AddressLine1' || childComponent?.key === 'AddressLine2' || childComponent?.key === 'postCodeText' || childComponent?.key === 'countryText' || childComponent?.key === 'primaryManualCity' || childComponent?.key === 'stateOrProvince') {
                      childComponent.hidden = false;
                    }
                  });
                });
              } else if (component?.key === 'manualDateGrid') {
                component && component.components.forEach((subComponent) => {
                  subComponent && subComponent.forEach((childComponent) => {
                    if (childComponent?.key === 'addressFrom' || childComponent?.key === 'addressTo') {
                      childComponent.hidden = true;
                      component.hidden = true;
                    }
                  });
                });
                component && component.components.forEach((subComponent) => {
                  subComponent && subComponent.forEach((childComponent) => {
                    if (childComponent?.key === 'addressFrom' || childComponent?.key === 'addressTo') {
                      childComponent.hidden = true;
                      component.hidden = true;
                    }
                  });
                });
              } else if (component?.key === 'primaryAddressGrid') {
                component && component.components.forEach((subComponent) => {
                  subComponent && subComponent.forEach((childComponent) => {
                    if (childComponent?.key === 'manualAddressToggle') {
                      if (this.formInput.data[this.personalInformationPage].isAddressLookUpEnabled === 'false') {
                        childComponent.disabled = true;
                      }
                    }
                  });
                });
              }
            });
          }
        }
        if (this.applicantType === 'primary' && ['savings', 'termDeposit'].includes(this.getProductType)) {
          this.accountOwnershipDataSaved();
        }
      } else if (this.$route.query.type === 'PersonalInformation' && this.savePersonalResponse.data.personalInformation !== null) {
        this.resumeContactInformation = JSON.parse(this.savePersonalResponse.data.contactInformation);
        const statusInformation = JSON.parse(this.savePersonalResponse.data.statusInformation);
        const productMapping = store?.getters['userStore/userData']?.productInfo;

        this.formInput.data[this.additionalInformationPage].b2bSessionId = this.savePersonalResponse.data?.b2bSessionId;
        this.formInput.data[this.personalInformationPage].identityVerificationEnabled1 = (!statusInformation?.identityVerificationEnabled || statusInformation?.identityVerificationEnabled === 'false') || (this.profileImage && this.profileImage.data && this.profileImage.data.length > 0);
        const otherInformation = JSON.parse(this.savePersonalResponse.data.otherInformation);
        const transferInValidation = otherInformation && otherInformation?.lisaTransferInWithAgeValidation !== undefined && otherInformation?.lisaTransferInWithAgeValidation !== null ? otherInformation?.lisaTransferInWithAgeValidation : localStorage.getItem('isLisaTransferInWithAgeCheck');
        const isLisaTransferInWithAgeCheck = transferInValidation;

        localStorage.setItem('isLisaTransferInWithAgeCheck', isLisaTransferInWithAgeCheck);
        this.partialDataSaved(this.lisaEligibilityPassed, this.formInput, this.dataObj);
        this.formInput.data[this.personalInformationPage].productSubType = this.getProductType;
        this.formInput.data[this.personalInformationPage].module = productMapping.data.module;
        if (['cashISA', 'lifetimeISA', 'noticeDeposit', 'currentAccount'].includes(this.getProductType)) {
          this.formInput.data[this.personalInformationPage].accountOwnership = 'SOLE';
          this.formInput.data[this.personalInformationPage].modeOfOperation = 'SOLE';
        }
        this.IDVForSecondaryApplicant = !(localStorage.getItem('IDVForSecondaryApplicant') === 'false' || localStorage.getItem('IDVForSecondaryApplicant') === false);
        if (this.formInput.data[this.personalInformationPage].identityVerificationEnabled1 || !this.IDVForSecondaryApplicant) {
          const idvWizard = this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components;

          idvWizard.forEach((grid) => {
            if (grid.key === 'identityGrid' || grid.key === 'taxGrid') {
              if (grid?.components && grid.components.length > 0) {
                for (let index = 0; index < grid.components.length; index++) {
                  for (let subComponent = 0; subComponent < grid.components[index].length; subComponent++) {
                    if (grid.components[index][subComponent].type === 'file') {
                      grid.components[index][subComponent].hidden = false;
                    } else if (grid.components[index][subComponent].type === 'HTMLcontent' && grid.key !== 'taxGrid') {
                      grid.components[index][subComponent].hidden = false;
                    }
                  }
                }
              }
            }
          });
        }
      } else if (this.$route.query.type === 'AdditionalInformation') {
        this.response.entityId = this.savePersonalResponse.data.entityId;
        this.partialDataSaved();
        const statusInformation = JSON.parse(this.savePersonalResponse.data.statusInformation);

        this.formInput.data.page2.identityVerificationEnabled1 = statusInformation && statusInformation?.identityVerificationEnabled !== null ? !(statusInformation.identityVerificationEnabled) : ((this.profileImage && this.profileImage.data && this.profileImage.data.length > 0));
        if (this.formInput.data[this.personalInformationPage].identityVerificationEnabled1 || !this.IDVForSecondaryApplicant) {
          const idvWizard = this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType]?.personalInformation[0]].components;

          idvWizard.forEach((grid) => {
            if (grid.key === 'identityGrid' || grid.key === 'taxGrid') {
              if (grid?.components && grid.components.length > 0) {
                for (let index = 0; index < grid.components.length; index++) {
                  for (let subComponent = 0; subComponent < grid.components[index].length; subComponent++) {
                    if (grid.components[index][subComponent].type === 'file') {
                      grid.components[index][subComponent].hidden = false;
                    } else if (grid.components[index][subComponent].type === 'HTMLcontent' && grid.key !== 'taxGrid') {
                      grid.components[index][subComponent].hidden = false;
                    }
                  }
                }
              }
            }
          });
        }
        this.additionalDetailsPartialData(this.formInput, this.dataObj);
        this.$forceUpdate();
      }
      if (['savings', 'termDeposit'].includes(this.getProductType) && ['SOLE', 'SINGLE'].includes(this.productData.data?.applicableAccountOperationType)) {
        // this loop is added as accountInformation tab should not be clickable when account type is coming as SINGLE from essence.
        this.dataObj.data.wizardSteps[pageBasedOnProducts[this.getProductType][this.applicantType].accountInformation[0]].isClickable = false;
      }
      this.formInput.moveToNextPanel = { type: undefined, index: this.index };
      if (this.profileImage && this.profileImage.data && this.profileImage.data.length > 0) {
        this.formInput.resumeFileUpload = {
          document: true,
          key: 'photoDocument',
          value: {
            name: this.profileImage.data[0].documentName,
            type: this.profileImage.data[0].documentType,
          },
          response: this.profileImage.data[0],
        };
      } else if (this.profileImage && this.profileImage.data && this.profileImage.data.length === 0 && this.identityDocuments && this.identityDocuments.data && this.identityDocuments.data.length > 0) {
        this.formInput.resumeFileUpload = {
          key: this.identityDocuments.data[0].documentSubCategoryId === this.$appSettings.documentSubCategoryId.NATIONAL_ID_001 ? 'passportDocument' : this.identityDocuments.data[0].documentSubCategoryId === this.$appSettings.documentSubCategoryId.NATIONAL_ID_001 ? 'drivingLicenseDocument' : this.identityDocuments.data[0].documentSubCategoryId === this.$appSettings.documentSubCategoryId.NATIONAL_ID_003 ? 'nationalInsuranceDocument' : '',
          value: {
            name: this.identityDocuments.data[0].documentName,
            type: this.identityDocuments.data[0].documentType,
          },
          response: this.identityDocuments.data[0],
        };
      }
      this.formInput.additionalHelperData = this.$appSettings?.dcoConfigurations?.displayApplicationNumber ? (this.savePersonalResponse && this.savePersonalResponse.data && this.savePersonalResponse.data.applicationNumber) : '';
      this.formInput.data.page2.entityId1 = this.savePersonalResponse && this.savePersonalResponse.data && this.savePersonalResponse.data.entityId;
      if (this.$route.query.type === 'AdditionalInformation') {
        const getFileValue = await CommonService.getDocumentUpload(`${urlObj.upload}/${this.response.entityId}/${'FECO_PROOF_CATEGORY_ACCOUNT'}`, { b2bSessionId: this.savePersonalResponse.data?.b2bSessionId });
        this.fileStatus = getFileValue.data;
        if (this.fileStatus) {
          this.count = 1;
        }
      }
    },
    formInput: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.updateWatchFunctions(newVal);
        }
      },
      deep: true,
    },
  },
};
</script>
